// Trilingual translations for Talkani Logistik
export const translations = {
  de: {
    nav: { home: "Startseite", services: "Leistungen", about: "Über uns", contact: "Kontakt", dashboard: "Mein Konto", admin: "Admin", login: "Anmelden", logout: "Abmelden", book: "Jetzt buchen", blog: "Blog", b2b: "Geschäftskunden" },
    trusted_by: {
      label: "Bereits im Einsatz für",
      subtitle: "Wiederkehrende Aufträge von Werkstätten & Sharing-Anbietern in Norddeutschland.",
      and_more: "+ Alle Fallstudien"
    },
    b2b_banner: {
      eyebrow: "Ihr Business-Partner",
      title: "Talkani arbeitet für Ihr Unternehmen.",
      subtitle: "Werkstätten, Werbeagenturen, Hausverwaltungen, Schulen, Hotels und Onlineshops in Hamburg vertrauen uns tägliche Lieferungen, Reinigungen und Fahrten an — mit einer einzigen Monatsrechnung, festen Ansprechpartnern und bis zu 15% Mengenrabatt.",
      cta_primary: "Als Firma buchen",
      cta_secondary: "Für Entwickler: API-Docs",
      industries_label: "Wir arbeiten für:",
      ind_werkstatt: "Kfz-Werkstätten",
      ind_agentur: "Werbeagenturen",
      ind_hausverwaltung: "Hausverwaltungen",
      ind_hotel: "Hotels & Gastronomie",
      ind_schule: "Schulen & Behörden",
      ind_shop: "Onlineshops",
      stat1: "1 Rechnung / Monat",
      stat1_sub: "Statt Einzelrechnungen",
      stat2: "Automatisierbar",
      stat2_sub: "Anbindung ans ERP",
      stat3: "bis 15% Rabatt",
      stat3_sub: "ab 25 Aufträgen/Monat",
      stat4: "90-Min.-Garantie",
      stat4_sub: "Express vertraglich",
    },
    b2b_lead: {
      eyebrow: "Angebot anfragen",
      title: "In 15 Minuten zum Business-Angebot.",
      subtitle: "Sie füllen 5 Felder aus — wir melden uns binnen 24 Stunden mit einem persönlichen Angebot inkl. Mengenrabatt und Ansprechpartner.",
      f_company: "Firmenname",
      f_company_ph: "z.B. Musterwerkstatt GmbH",
      f_name: "Ansprechpartner",
      f_name_ph: "Vor- und Nachname",
      f_email: "E-Mail",
      f_email_ph: "max@firma.de",
      f_phone: "Telefon (optional)",
      f_phone_ph: "+49 175 …",
      f_volume: "Erwartetes Volumen",
      f_volume_help: "Ungefähre Anzahl Aufträge pro Monat",
      vol_under_10: "unter 10/Monat",
      vol_10_25: "10–25/Monat",
      vol_25_100: "25–100/Monat",
      vol_100_plus: "100+/Monat",
      f_interest: "Interesse",
      int_lieferung: "Lieferungen & Kurierdienst",
      int_autoteile: "Autoteile an Werkstätten",
      int_reinigung: "Reinigung (Objekt / Büro / Endreinigung)",
      int_umzug: "Umzüge",
      int_escooter: "E-Scooter Service",
      int_plakatservice: "Plakatservice / OoH",
      int_gartenpflege: "Gartenpflege & Winterdienst",
      int_other: "Sonstiges",
      f_message: "Kurze Beschreibung (optional)",
      f_message_ph: "Was brauchen Sie regelmäßig? Wo? Wann?",
      submit: "Angebot anfordern",
      sending: "Wird gesendet…",
      success_title: "Danke — wir melden uns binnen 24 h.",
      success_body: "Ihre Anfrage ist bei uns eingegangen. Sie erhalten in Kürze eine Bestätigungs-E-Mail.",
      error_generic: "Etwas ist schiefgelaufen. Bitte versuchen Sie es erneut oder rufen Sie +49 175 8802646 an.",
      required: "Bitte füllen Sie alle Pflichtfelder aus."
    },
    b2b: {
      meta_title: "Talkani B2B — Geschäftskunden | Sammelrechnung · API · SLA",
      meta_desc: "Logistik & Service für Werkstätten, Werbeagenturen, Hausverwaltungen, Schulen, Hotels & Onlineshops. Monatliche Sammelrechnung, API-Integration und garantierter Express-SLA.",
      hero_eyebrow: "Talkani Business",
      hero_title_line1: "Logistik, die Ihr",
      hero_title_line2: "Tagesgeschäft trägt.",
      hero_subtitle: "Für Werkstätten, Werbeagenturen, Hausverwaltungen, Schulen, Hotels und Onlineshops mit wiederkehrendem Bedarf — mit monatlicher Sammelrechnung, API-Anbindung und persönlichem Account Manager.",
      hero_cta_call: "Beratung anfragen",
      hero_cta_api: "API ansehen",
      hero_cta_trial: "Probebuchung starten",
      segments_eyebrow: "Für wen?",
      segments_title: "Ihre Branche, unser Service.",
      seg_werkstatt_label: "Kfz-Werkstätten",
      seg_werkstatt_text: "Express-Autoteile-Lieferung von Großhändler zur Werkstatt in 90 Min. Tages- & Wochenverträge.",
      seg_werkstatt_case1: "Bremsen / Filter / Batterien",
      seg_werkstatt_case2: "Same-Day Express",
      seg_werkstatt_case3: "20% Rabatt im Vertrag",
      seg_werbung_label: "Werbeagenturen & OoH",
      seg_werbung_text: "Plakatwechsel (City-Light-Poster, Großflächen, Litfaßsäulen) zuverlässig in ganz Norddeutschland.",
      seg_werbung_case1: "CLP-Wechsel an Bushaltestellen",
      seg_werbung_case2: "Baustellenzaun-Bekleben",
      seg_werbung_case3: "Foto-Doku jeder Stelle",
      seg_hv_label: "Hausverwaltungen",
      seg_hv_text: "Treppenhausreinigung, Regenrinne, Gartenpflege und Winterdienst für ganze Liegenschaftsbestände.",
      seg_hv_case1: "Wöchentliche Reinigung",
      seg_hv_case2: "Saisonverträge",
      seg_hv_case3: "Notdienst rund um die Uhr",
      seg_schule_label: "Schulen & Behörden",
      seg_schule_text: "Reinigung und Logistik für öffentliche Einrichtungen — VOL/A-konform und mit Ausschreibungserfahrung.",
      seg_schule_case1: "Schul- & Kita-Reinigung",
      seg_schule_case2: "Universitäten & Behörden",
      seg_schule_case3: "Sicherheitsüberprüftes Personal",
      seg_hotel_label: "Hotels & Gastronomie",
      seg_hotel_text: "Tageweise Reinigungspersonal, Wäschelogistik, Außenfassaden- und Fenstereinigung.",
      seg_hotel_case1: "Zimmerreinigung",
      seg_hotel_case2: "Banketträume",
      seg_hotel_case3: "Außenflächen & Beschilderung",
      seg_shop_label: "Onlineshops",
      seg_shop_text: "Same-Day-Delivery für Hamburg & Umland. Eilige Sendungen, sperrige Güter, Retouren.",
      seg_shop_case1: "Same-Day in 4h",
      seg_shop_case2: "Sperrgut bis 2 m³",
      seg_shop_case3: "Foto-Beweis bei Übergabe",
      features_eyebrow: "Was Sie bekommen",
      features_title: "6 Gründe für Talkani Business.",
      f_invoice_title: "Sammelrechnung",
      f_invoice_text: "Eine Rechnung pro Monat — DATEV-kompatibel, automatisch versendet.",
      f_api_title: "API & Webhooks",
      f_api_text: "Integrieren Sie Talkani direkt in Ihr Warenwirtschaftssystem (REST + Webhooks).",
      f_sla_title: "Express-SLA",
      f_sla_text: "Garantierte Antwortzeit 90 Min. — vertraglich zugesichert.",
      f_account_title: "Account Manager",
      f_account_text: "Persönlicher Ansprechpartner für alle Anliegen.",
      f_gdpr_title: "DSGVO & AVV",
      f_gdpr_text: "Auftragsverarbeitungsvertrag auf Anfrage. Voll DSGVO-konform.",
      f_scale_title: "Skalierbar",
      f_scale_text: "Von 5 bis 5.000 Aufträgen pro Monat. Faire Mengenrabatte.",
      api_badge: "Entwickler-Schnittstelle",
      api_title: "Integrieren Sie Talkani in 1 Tag.",
      api_intro_pre: "Wenn Ihr ERP, Ihr Werkstattsystem oder Ihre Disposition-Software heute schon REST spricht, können Sie Talkani in ",
      api_intro_strong: "weniger als 8 Stunden",
      api_intro_post: " anbinden. Keine Lizenzkosten — Sie zahlen nur für ausgeführte Aufträge.",
      api_b1_b: "OpenAPI 3.1",
      api_b1: " — Interaktive Swagger-Doku, getestet mit jedem HTTP-Client",
      api_b2_b: "JSON ein → JSON raus",
      api_b2: " — Keine SOAP-Schmerzen, kein XML-Hokuspokus",
      api_b3_b: "Webhooks",
      api_b3: " — Statusupdates werden zu Ihrem Endpoint gepusht, kein Polling nötig",
      api_b4_b: "Sandbox + Production",
      api_b4: " — Testen Sie auf einer separaten Umgebung, gehen Sie live, wenn Sie bereit sind",
      api_b5_b: "Code-Beispiele",
      api_b5: " — cURL, Python, Node.js, PHP — direkt aus der Doku kopierbar",
      api_open_docs: "API-Dokumentation öffnen",
      api_request_key: "Partner-Key anfragen",
      api_code_response: "# Antwort",
      steps_eyebrow: "In 4 Schritten",
      steps_title: "So gehen Sie live.",
      step1_title: "1. Dokumentation lesen",
      step1_text: "Öffnen Sie /api/docs — eine vollständige, interaktive OpenAPI-Spezifikation aller Endpunkte.",
      step2_title: "2. Partner-Key anfragen",
      step2_text: "Schreiben Sie an info@talkani.de — wir senden Ihnen ein API-Token + AVV-Entwurf.",
      step3_title: "3. Integrieren",
      step3_text: "REST-Calls direkt aus Ihrem ERP / Dispatch-System. JSON ein, JSON raus.",
      step4_title: "4. Webhooks erhalten",
      step4_text: "Statusänderungen (eingegangen → bestätigt → unterwegs → erledigt) landen automatisch in Ihrem System.",
      pricing_eyebrow: "Mengenrabatte",
      pricing_title: "Fair skaliert mit Ihrem Volumen.",
      tier_starter: "Starter",
      tier_starter_jobs: "bis 25 / Monat",
      tier_starter_rabatt: "0%",
      tier_growth: "Growth",
      tier_growth_jobs: "25 – 100 / Monat",
      tier_growth_rabatt: "8%",
      tier_enterprise: "Enterprise",
      tier_enterprise_jobs: "100+ / Monat",
      tier_enterprise_rabatt: "individuell",
      tier_discount_label: "Mengenrabatt",
      tier_f1: "Sammelrechnung",
      tier_f2: "Account Manager",
      tier_f3: "Express-SLA",
      tier_f4: "API-Zugang",
      final_cta_title: "Gespräch vereinbaren.",
      final_cta_text: "In 15 Min. besprechen wir Ihren Bedarf und erstellen ein individuelles Angebot.",
    },
    hero: {
      eyebrow: "TALKANI GMBH · LOGISTIK · REINIGUNG · SERVICE FÜR UNTERNEHMEN",
      title: "Schnell. Zuverlässig. Flexibel.",
      subtitle: "Ihr Logistik- und Reinigungspartner in Hamburg — Paketlieferungen, Autoteile-Belieferung, 2 Mann Handling mit Möbelmontage, Reinigungen für Hausverwaltungen und Hotels, Umzüge und der nächtliche E-Scooter-Service für Sharing-Anbieter. Wir arbeiten für Werkstätten, Onlineshops, Firmen und Privathaushalte in Hamburg und ganz Norddeutschland.",
      cta_primary: "Service buchen",
      cta_secondary: "Leistungen ansehen"
    },
    about_intro: {
      eyebrow: "ÜBER UNS",
      title: "Mehr als nur Logistik.",
      body: "Talkani ist ein modernes Dienstleistungsunternehmen für Logistik, Reinigung und Service. Wir übernehmen den zuverlässigen Transport und die termingerechte Zustellung von Paketen, Lebensmitteln, Medikamenten, Backwaren, Blumen sowie weiteren sensiblen und zeitkritischen Lieferungen. Als flexibles Dienstleistungsunternehmen sind wir offen für individuelle Wünsche — sprechen Sie uns einfach an, wir entwickeln eine maßgeschneiderte Lösung.",
      stat1_value: "10+", stat1_label: "Dienstleistungen",
      stat2_value: "24/7", stat2_label: "Verfügbarkeit",
      stat3_value: "100%", stat3_label: "Zuverlässigkeit"
    },
    services: {
      eyebrow: "UNSERE LEISTUNGEN",
      title: "Alles aus einer Hand.",
      lieferung: { name: "Lieferung & Zustellung", desc: "Sichere und pünktliche Zustellung aller Sendungen — wir liefern: • Pakete & Päckchen (Same-Day in Hamburg) • Lebensmittel & Einkäufe (Kühlung auf Wunsch) • Medikamente & Apothekenfahrten • Backwaren & Frische (frühmorgens) • Blumen & sensible Sendungen • Dokumente & Express-Kurier • Getränke & Großeinkäufe. GPS-Tracking, Foto-Nachweis bei Übergabe und persönliche Fahrer — Ihre Sendung bekommt einen Namen, kein Tracking-Code." },
      escooter_service: { name: "E-Scooter Service", desc: "Komplette Flotten-Logistik für E-Scooter-Anbieter — wir übernehmen: • Batterie-Laden & Austausch in der Nacht • Transport defekter Fahrzeuge zur Werkstatt • Verteilung einsatzbereiter Scooter in Hotspot-Zonen • Hol- & Bringdienst zwischen Lager und Stadtgebiet • Reinigung & Pflege der Fahrzeuge • Inventur und Standort-Reports. Skalierbar von 50 bis 5.000 Fahrzeugen — für Sharing-Services in Hamburg und ganz Norddeutschland." },
      umzug: { name: "Umzug, Entrümpelung, Reinigung & Malerarbeiten", desc: "Ihr Komplett-Umzug aus einer Hand — wir übernehmen: • Möbeltransport & gepolstertes Verladen • Verpackung mit Kartons & Materialien • Möbel-Auf- und -Abbau (auch IKEA) • Entrümpelung von Wohnung, Keller und Dachboden • Gründliche Endreinigung (besenrein bis spiegelblank) • Malerarbeiten (Wände streichen, Reparaturen, Renovierung) • Klaviertransport & Spezialmöbel. Festpreis-Garantie, keine versteckten Kosten, ein Ansprechpartner für alles." },
      reinigung: { name: "Reinigung (Alle Arten)", desc: "Professionelle Reinigung für alle Gebäude und Räume — wir decken folgende Bereiche ab: • Treppenhausreinigung (Hausverwaltungen / Mehrfamilienhäuser) • Fenster- und Glasreinigung (innen & außen, auch hohe Etagen) • Büroreinigung & Praxisreinigung • Behörden, Universitäten, Schulen, Kindergärten & Bildungszentren • Hotels, Geschäftsräume, Praxen & Einzelhandel • Müllraum- und Hofreinigung • Graffiti-Entfernung (Fassaden, Garagentore, Schaufenster — schonende Verfahren ohne Beschädigung des Untergrunds) • Grundreinigung & Baureinigung (nach Renovierung). Mit professioneller Ausrüstung und geschultem Personal — auf Wunsch nach Geschäftsschluss oder als regelmäßiger Wartungsvertrag." },
      hausreinigung: { name: "Hausreinigung & Privathaushalt", desc: "Regelmäßige oder einmalige Reinigung Ihres Zuhauses — wir reinigen: • Wohn- und Schlafzimmer • Küche (Arbeitsflächen, Geräte, Schränke außen) • Badezimmer (Sanitär, Fliesen, Spiegel) • Fenster, Türen & Böden • Staubwischen & Spinnweben entfernen • Müll entsorgen & Bettwäsche wechseln (auf Wunsch). Eigene umweltfreundliche Materialien, diskrete und gewissenhafte Mitarbeiter — wiederkehrend wöchentlich, 14-tägig oder monatlich. Ideal für Familien, Berufstätige und Senioren." },
      gartenpflege: { name: "Gartenpflege & Gartenreinigung", desc: "Komplette Pflege Ihres Gartens — Saison für Saison: • Rasen mähen, vertikutieren & düngen • Hecken- und Strauchschnitt (alle Höhen) • Unkraut entfernen (mechanisch & thermisch) • Wege, Terrassen & Pflaster reinigen • Laub entfernen & entsorgen • Frühjahrs- und Herbstaufräumung • Baumpflege & Sturmschadenbeseitigung • Friedhofspflege & Grabbepflanzung. Wiederkehrend (wöchentlich, 14-tägig, monatlich) für Privatgärten, Mehrfamilienhäuser und Gewerbeflächen." },
      autoteile: { name: "Autoteile-Lieferung an Werkstätten", desc: "Schnelle Werkstatt-Logistik in Hamburg und Umland — wir liefern: • Bremsen, Filter & Verschleißteile • Batterien, Lichtmaschinen & Anlasser • Spiegel, Scheiben & Karosserieteile • Öle, Schmiermittel & Betriebsstoffe • Werkzeuge & Verbrauchsmaterial • Reifen & Felgen (auch saisonale Abholung). Mehrmals täglich, taggleich (Same-Day) oder Express in 90 Minuten. B2B-Rahmenverträge mit monatlicher Sammelrechnung." },
      regenrinne_reinigung: { name: "Rohr- & Regenrinnen-Reinigung mit Kamera", desc: "Professionelle Reinigung mit voller Transparenz — unser Service umfasst: • Reinigung von Dachrinnen & Fallrohren • Innen-Inspektion mit Rohrkamera (Endoskop) • Hochdruck-Spülung der Abflussleitungen • Vollständige Video-Dokumentation • Vorher/Nachher-Fotos jedes Bauteils • Empfehlung für Wartungsintervalle. Auch für Mehrfamilienhäuser, Gewerbeobjekte und Hausverwaltungen — mit detailliertem Bericht für Ihre Akten." },
      winterdienst: { name: "Winterdienst & Schneeräumung", desc: "Räum- und Streupflicht professionell erfüllt — wir übernehmen: • Schneeräumung von Gehwegen, Zufahrten & Höfen • Streuen mit Salz oder umweltfreundlichem Granulat • Räumung von Straßen, Parkplätzen & Betriebsflächen • 24/7 Bereitschaftsdienst bei Schneefall • Saisonverträge mit Festpreis (November–März) • Glatteis-Bekämpfung & Eisaufbruch. Maximale Sicherheit für Anwohner, Mitarbeiter und Kunden — wir haften für die rechtskonforme Räumung." },
      zweimann_handling: { name: "2 Mann Handling & Möbelmontage", desc: "Zuverlässige 2 Mann Zustellung für schwere Sendungen und Großmöbel — wir übernehmen: • Sofas, Betten & Schrankwände (mit Rutschmatten & Kantenschutz) • Waschmaschinen, Kühlschränke & Geschirrspüler • Küchenschränke und Küchen komplett (auf Wunsch mit Anschluss) • Große TV-Geräte 65\" und größer • Fitness-Geräte & Massagesessel • Bis zum 4. OG ohne Aufzug, mit Aufzug alle Etagen • Möbelmontage nach Anleitung • Verpackungsmitnahme & Altgeräteentsorgung (EAR-registriert). Ideal für Online-Shops, Hausverwaltungen und Privatkunden. Ab €59 Standard · €89 Handling+ · €149 Full-Service." },
      plakatservice: { name: "Plakatservice — Außenwerbung & Plakatwechsel", desc: "Professionelle Außenwerbungs-Logistik für Agenturen und Veranstalter — wir bieten: • City-Light-Poster (CLP) an Bushaltestellen • Großflächen (18/1) & Mega-Light • Litfaßsäulen & Plakatwände • Plakatklebung an Bauzäunen • Aufkleber- und Sticker-Kampagnen • Last-Minute-Wechsel & Express-Aushang • Foto-Nachweis (Vorher/Nachher + GPS pro Standort) • Fachgerechte Entsorgung der alten Plakate. Kompatibel mit JCDecaux, Ströer, Wall, Awk und weiteren Trägersystemen — termingerecht, dokumentiert, zuverlässig." }
    },
    specialty: {
      eyebrow: "SPEZIELLE LIEFERUNGEN",
      title: "Wir liefern alles. Sicher, frisch, pünktlich.",
      subtitle: "Egal was Sie versenden möchten — wir haben die passende Lösung. Hier einige unserer Spezialitäten:",
      blumen: { name: "Blumen", desc: "Frische Blumensträuße und Pflanzen — sorgfältig verpackt, schnell zugestellt. Ideal für Geburtstage, Jubiläen oder Anlässe." },
      backwaren: { name: "Backwaren", desc: "Frische Brötchen, Croissants, Kuchen und Backwaren — direkt von der Bäckerei zu Ihnen oder Ihren Kunden, noch warm und frisch." },
      zeitungen: { name: "Zeitungen", desc: "Zuverlässige Frühzustellung von Tages- und Wochenzeitungen — pünktlich vor dem ersten Kaffee, bei Wind und Wetter." },
      medikamente: { name: "Medikamente", desc: "Diskrete, sichere Zustellung von Apotheken-Produkten und Medikamenten — temperaturkontrolliert und vertraulich." },
      andere: { name: "Andere Dienstleistung", desc: "Sie brauchen etwas, das nicht in unserer Liste steht? Kein Problem — beschreiben Sie uns einfach Ihren Wunsch, wir entwickeln eine maßgeschneiderte Lösung für Sie." }
    },
    testimonials: {
      eyebrow: "KUNDENSTIMMEN",
      title: "Was unsere Kunden sagen.",
      subtitle: "Echte Bewertungen unserer Kunden — ungeschönt und direkt.",
      empty_title: "Noch keine Bewertungen.",
      empty_body: "Seien Sie der oder die Erste! Wir freuen uns über Ihr Feedback nach jedem Auftrag.",
      write_btn: "Bewertung schreiben",
      form_title: "Ihre Bewertung",
      form_name: "Ihr Name (öffentlich sichtbar)",
      form_role: "Funktion / Firma (optional)",
      form_rating: "Sterne",
      form_text: "Was sagen Sie über unseren Service?",
      form_submit: "Bewertung abschicken",
      form_cancel: "Abbrechen",
      form_login_required: "Bitte zuerst anmelden, um eine Bewertung abzugeben.",
      form_success: "Vielen Dank für Ihre Bewertung!"
    },
    values: {
      eyebrow: "WARUM TALKANI",
      title: "Werte, auf die Sie sich verlassen können.",
      reliability: { title: "Zuverlässigkeit", desc: "Pünktlich, gewissenhaft, professionell — bei jedem Auftrag." },
      quality: { title: "Qualität", desc: "Geschultes Team und effiziente Arbeitsprozesse für höchste Qualität." },
      flexibility: { title: "Flexibilität", desc: "Maßgeschneiderte Lösungen für individuelle Anforderungen." },
      satisfaction: { title: "Kundenzufriedenheit", desc: "Ihre Zufriedenheit steht für uns immer an erster Stelle." }
    },
    cta_banner: { title: "Bereit, Ihren Auftrag zu starten?", subtitle: "Buchen Sie online in unter 60 Sekunden.", button: "Jetzt buchen" },
    contact: {
      eyebrow: "KONTAKT",
      title: "Sprechen Sie mit uns.",
      name: "Name", email: "E-Mail", phone: "Telefon", subject: "Betreff", message: "Ihre Nachricht", send: "Nachricht senden",
      sent: "Nachricht gesendet — wir melden uns in Kürze.",
      address_label: "Adresse", phone_label: "Telefon", email_label: "E-Mail"
    },
    footer: { rights: "Alle Rechte vorbehalten.", imprint: "Impressum", privacy: "Datenschutz", agb: "AGB", cookies: "Cookie-Einstellungen" },
    voice: { title: "Sprach-Buchung · NEU", subtitle: "Sprechen Sie Ihren Auftrag ein — wir füllen das Formular automatisch.", start: "Aufnahme starten", stop: "Fertig", recording: "Aufnahme läuft…", processing: "Wird transkribiert…", transcript: "Transkript", again: "Erneut versuchen" },
    text_booking: { title: "Text-Buchung", subtitle: "Beschreiben Sie Ihren Auftrag in Worten — KI füllt das Formular automatisch.", start: "Text eingeben", submit: "Auto-füllen", cancel: "Abbrechen", processing: "Verarbeite…", placeholder: "z.B. 'Ich brauche morgen 14 Uhr einen Umzug von Eimsbüttel nach Altona, 2 Zimmer'", error: "Keine Felder erkannt — bitte präziser beschreiben." },
    auth: {
      sign_in: "Mit Google anmelden", sign_in_title: "Willkommen zurück", sign_in_subtitle: "Melden Sie sich an, um Ihre Buchungen zu verwalten.",
      create_account: "Konto erstellen", create_account_subtitle: "Erstellen Sie Ihr persönliches Talkani-Konto.",
      tab_signin: "Anmelden", tab_register: "Registrieren",
      password: "Passwort", or: "oder",
      sign_in_btn: "Anmelden", create_account_btn: "Konto erstellen",
      processing: "Anmeldung läuft...",
      forgot_password: "Passwort vergessen?",
      forgot_title: "Passwort zurücksetzen",
      forgot_subtitle: "Geben Sie Ihre E-Mail-Adresse ein. Wir senden Ihnen einen Link zum Zurücksetzen.",
      forgot_submit: "Link senden",
      forgot_sent_title: "Link gesendet",
      forgot_sent_body: "Wenn ein Konto mit dieser E-Mail existiert, haben wir einen Link zum Zurücksetzen geschickt. Prüfen Sie auch Ihren Spam-Ordner. Der Link ist 30 Minuten gültig.",
      back_to_login: "Zurück zur Anmeldung",
      reset_title: "Neues Passwort vergeben",
      reset_subtitle: "Wählen Sie ein starkes neues Passwort für Ihr Talkani-Konto.",
      reset_new_password: "Neues Passwort",
      reset_confirm_password: "Passwort bestätigen",
      reset_password_hint: "Mindestens 8 Zeichen. Empfohlen: Buchstaben, Zahlen und Sonderzeichen.",
      reset_password_too_short: "Das Passwort muss mindestens 8 Zeichen lang sein.",
      reset_password_mismatch: "Die Passwörter stimmen nicht überein.",
      reset_submit: "Passwort speichern",
      reset_success_title: "Passwort aktualisiert",
      reset_success_body: "Ihr Passwort wurde erfolgreich geändert. Sie werden gleich zur Anmeldung weitergeleitet.",
      reset_invalid_title: "Ungültiger Link",
      reset_invalid_body: "Dieser Link zum Zurücksetzen ist ungültig oder abgelaufen. Bitte fordern Sie einen neuen Link an.",
      reset_invalid_link: "Der Link ist ungültig. Bitte fordern Sie einen neuen an."
    },
    booking: {
      title: "Service buchen", step: "Schritt", of: "von",
      step1: "Service wählen", step2: "Datum & Zeit", step3: "Details", step4: "Bestätigen",
      step1_main: "Hauptleistungen", step1_specialty: "Speziallieferungen",
      date: "Datum", time: "Uhrzeit", name: "Name", email: "E-Mail", address: "Adresse", phone: "Telefon", details: "Zusätzliche Details (optional)",
      details_custom: "Beschreiben Sie Ihren Wunsch",
      details_custom_placeholder: "Was möchten Sie geliefert / erledigt haben? Bitte beschreiben Sie kurz Ihre Anforderung.",
      back: "Zurück", next: "Weiter", confirm: "Buchung bestätigen", success: "Buchung erfolgreich!", success_msg: "Wir senden Ihnen eine Bestätigung per E-Mail.",
      view_bookings: "Meine Buchungen ansehen",
      have_code: "Empfehlungs- oder Rabattcode hinzufügen",
      referral_code_label: "Empfehlungscode",
      discount_code_label: "Rabattcode",
      referral_valid: "Code von {name} gültig — Sie sparen {eur} €",
      referral_invalid: "Code ungültig oder abgelaufen.",
      code_note: "Beide Codes sind optional. Wir berechnen den finalen Preis und ziehen den Rabatt vor der Bestätigung ab."
    },
    dashboard: {
      title: "Meine Buchungen", new_booking: "Neue Buchung", empty: "Sie haben noch keine Buchungen.", book_now: "Jetzt buchen",
      status: { pending: "Ausstehend", confirmed: "Bestätigt", in_progress: "In Bearbeitung", completed: "Abgeschlossen", cancelled: "Storniert" }
    },
        admin_analytics: { eyebrow: "Analytics", title: "Buchungs-Auswertung", subtitle: "Wöchentliche Übersicht: bestätigt vs. storniert pro Service.", weekly_title: "Wöchentlicher Verlauf", by_service_title: "Buchungen je Service" },
    cookie_consent: {
      aria_label: "Cookie-Einstellungen",
      banner_title: "Wir schätzen Ihre Privatsphäre.",
      banner_body: "Wir setzen essenzielle Cookies für die Website. Zusätzlich möchten wir mit Ihrer Einwilligung anonyme Nutzungsstatistiken und Marketing-Cookies verwenden. Sie können jederzeit widerrufen.",
      privacy_link: "Datenschutz",
      imprint_link: "Impressum",
      accept_all: "Alle akzeptieren",
      only_necessary: "Nur Notwendige",
      settings: "Einstellungen",
      settings_title: "Cookie-Einstellungen",
      settings_body: "Wählen Sie, welche Cookies wir setzen dürfen. Notwendige Cookies können nicht deaktiviert werden — ohne sie funktioniert die Buchung, das Login und die Sprachauswahl nicht.",
      cat_necessary_title: "Notwendig",
      cat_necessary_body: "Ermöglichen den technischen Betrieb der Seite (Session-Handling, Buchungsformular, Sprachauswahl). Ohne diese Cookies funktioniert die Website nicht korrekt.",
      cat_analytics_title: "Analyse",
      cat_analytics_body: "Anonyme Nutzungsstatistiken (welche Seiten werden besucht, welche Teaser klicken Kunden). Wir erstellen keine persönlichen Profile.",
      cat_marketing_title: "Marketing",
      cat_marketing_body: "Ermöglicht Empfehlungscodes, Kampagnen-Tracking und Öffnungs-Statistiken bei E-Mail-Bestätigungen.",
      item_session: "Session & Login (auth_session)",
      item_lang: "Sprachauswahl (de / en / ar)",
      item_booking_id: "Aktive Buchungs-ID zur Nachverfolgung",
      item_teasers: "Chat-Teaser Impressionen (welcher Kontext-Teaser bereits gezeigt wurde)",
      item_chat_meta: "Anonyme Chat-Konversations-Metadaten (Sprache, Zeitzone)",
      item_referral: "Empfehlungscode-Tracking (?ref=…)",
      item_email_track: "E-Mail-Öffnungs-Tracking (Buchungs- und Statuseinladungen)",
      save_selection: "Auswahl speichern",
      footer_note: "Ihre Auswahl gilt für 12 Monate. Sie können sie jederzeit unter",
    },
    admin_leads: {
      eyebrow: "B2B-Pipeline",
      title: "Geschäftskunden-Anfragen",
      subtitle: "Alle eingehenden Business-Leads verwalten und im Pipeline-Status verfolgen.",
      total: "Gesamt",
      all: "Alle",
      status_new: "Neu",
      status_contacted: "Kontaktiert",
      status_qualified: "Qualifiziert",
      status_won: "Gewonnen",
      status_lost: "Verloren",
      mark_contacted: "Kontaktiert",
      mark_qualified: "Qualifizieren",
      mark_won: "Gewonnen",
      mark_lost: "Verloren",
      details: "Details",
      hide: "Zuklappen",
      message_label: "Nachricht des Kunden",
      empty: "Noch keine Anfragen in diesem Filter.",
      status_updated: "Status aktualisiert."
    },
    admin: { title: "Admin – Alle Buchungen", customer: "Kunde", service: "Service", datetime: "Datum/Zeit", status: "Status", actions: "Aktionen", update: "Aktualisieren", confirm: "Bestätigen", complete: "Erledigt", cancel: "Stornieren", reopen: "Wieder öffnen", delete: "Löschen", delete_test: "Test-Buchungen löschen", delete_test_confirm: "Alle Test-/QA-Buchungen (Refactor QA, test_*, example.com) wirklich löschen?", delete_confirm: "Diese Buchung wirklich löschen?", email_sent: "Kunde per E-Mail benachrichtigt" },
    calculator: {
      eyebrow: "PREISRECHNER",
      title: "Sofort-Preis ohne Anruf.",
      subtitle: "Bekommen Sie in wenigen Sekunden einen unverbindlichen Richtpreis für Ihren Auftrag. Final wird der Preis nach kurzer Rücksprache bestätigt.",
      disclaimer: "Alle Preise sind unverbindliche Schätzungen ab. Der endgültige Preis wird nach Prüfung des Auftrags fair und transparent kalkuliert.",
      tag: "TALKANI KALKULATOR",
      headline: "Ihren Preis sofort berechnen",
      field_service: "Service",
      field_size: "Umfang",
      field_distance: "Entfernung",
      size_small: "Klein",
      size_medium: "Mittel",
      size_large: "Groß",
      size_small_umzug: "1-Zimmer",
      size_medium_umzug: "2–3 Zimmer",
      size_large_umzug: "4+ Zimmer",
      size_small_reinigung: "Bis 2 Std.",
      size_medium_reinigung: "3–4 Std.",
      size_large_reinigung: "5–8 Std.",
      size_small_hausreinigung: "Wohnung bis 60 m²",
      size_medium_hausreinigung: "Haus 60–120 m²",
      size_large_hausreinigung: "Haus 120+ m²",
      size_small_gartenpflege: "Klein bis 100 m²",
      size_medium_gartenpflege: "Mittel 100–300 m²",
      size_large_gartenpflege: "Groß 300+ m²",
      size_small_autoteile: "Bis 5 Teile / Tour",
      size_medium_autoteile: "Tagesvertrag 5–20 Teile",
      size_large_autoteile: "Tagespauschale 20+ / Mehrfachtour",
      size_small_regenrinne_reinigung: "Einfamilienhaus",
      size_medium_regenrinne_reinigung: "Doppelhaus",
      size_large_regenrinne_reinigung: "Mehrfamilienhaus",
      size_small_winterdienst: "Einzeleinsatz",
      size_medium_winterdienst: "Mehrere Einsätze",
      size_large_winterdienst: "Saisonvertrag",
      result_label: "Ihr Richtpreis",
      from: "ab",
      cta_book: "Jetzt buchen",
      cta_contact: "Angebot anfragen",
      lieferung_note: "Inkl. Grundpauschale & km-Pauschale. Express-Lieferung auf Anfrage.",
      umzug_note: "Beinhaltet 2 Träger und Transport. Verpackung & Entrümpelung optional.",
      reinigung_note: "Min. 2 Stunden, inkl. Material und Anfahrt im Hamburger Umland.",
      hausreinigung_note: "Inkl. eigener Reinigungsmittel und Anfahrt. Rabatt bei wöchentlicher oder 14-tägiger Buchung.",
      gartenpflege_note: "Inkl. Geräte und Grünschnitt-Entsorgung bis 1 m³. Saisonvertrag: bester Preis ganzjährig.",
      autoteile_note: "Express in 90 Min. inkl. Rückgabe alter Teile. Tages- und Wochenverträge mit Sonderkonditionen.",
      regenrinne_note: "Inkl. Inspektion mit Rohrkamera und Video-Dokumentation.",
      winterdienst_note: "Pro Einsatz inkl. Streumittel. Saisonvertrag bietet besten Preis.",
      escooter_note: "Für Flotten-Operatoren: Individuelles Angebot je nach Stadt, Flottengröße und Service-Umfang.",
      plakatservice_note: "Für Werbeagenturen und Veranstalter: Individuelle Pauschalen je nach Format (CLP, Großfläche, Litfaßsäule), Anzahl der Standorte und Wechselintervall.",
      you_save: "Sie sparen",
      combo_title: "+ Endreinigung der alten Wohnung",
      combo_badge: "-20%",
      combo_desc: "Wir reinigen Ihre alte Wohnung nach dem Umzug — besenrein und übergabefertig. Sparen Sie 30 € im Bundle."
    },
    before_after: {
      eyebrow: "VORHER · NACHHER",
      title: "Sehen Sie den Unterschied.",
      subtitle: "Ziehen Sie den Regler — sehen Sie das echte Ergebnis. Reale Beispiele aus unseren Aufträgen.",
      disclaimer: "Beispielbilder zur Veranschaulichung typischer Ergebnisse. Auf Wunsch zeigen wir gerne Referenzen aus konkreten Aufträgen.",
      regenrinne_title: "Dachrinne · Verstopft → Sauber",
      regenrinne_desc: "Komplette Reinigung mit Kamera-Inspektion und Video-Dokumentation.",
      reinigung_title: "Gebäudereinigung · Vor & Nach",
      reinigung_desc: "Professionelle Reinigung von Büros, Treppenhäusern und Gewerbeflächen.",
      entruempelung_title: "Entrümpelung · Voll → Leer",
      entruempelung_desc: "Keller, Dachböden und Wohnungen — fachgerecht entrümpelt und besenrein."
    },
    trust: {
      eyebrow: "VERTRAUEN & QUALITÄT",
      title: "Worauf Sie zählen können.",
      subtitle: "Wir arbeiten seriös, transparent und mit echten deutschen Standards — von der Versicherung bis zur Festpreis-Garantie.",
      insured_title: "Familienbetrieb",
      insured_desc: "Persönlich geführt aus Hamburg. Versicherungsschutz im Aufbau — Status wird vor Auftrag transparent kommuniziert.",
      gdpr_title: "100% DSGVO-konform",
      gdpr_desc: "Ihre Daten bleiben in Deutschland. Verschlüsselte Übertragung, keine Weitergabe an Dritte.",
      hamburg_title: "Hamburger Familienbetrieb",
      hamburg_desc: "Talkani — Sitz in Hamburg, persönlich geführter Familienbetrieb in Gründung.",
      tax_title: "Saubere Rechnung",
      tax_desc: "Transparente Rechnung mit ausgewiesener MwSt. — für Privat- und Geschäftskunden voll absetzbar.",
      fixed_price_title: "Festpreis-Garantie",
      fixed_price_desc: "Was wir vorab vereinbaren, wird auch berechnet. Keine versteckten Kosten — niemals.",
      premium_equipment_title: "Geprüfte Profi-Technik",
      premium_equipment_desc: "Wir setzen geprüfte Profi-Geräte (Kärcher, Rohrkamera, Schneeräumtechnik) und geschultes Personal ein."
    },
    team: {
      eyebrow: "UNSER TEAM",
      title: "Menschen, die liefern.",
      subtitle: "Hinter Talkani steht ein eingespieltes Team aus Logistik-, Reinigungs- und Servicespezialisten — alle mit einem Ziel: Ihre Zufriedenheit.",
      owner_tag: "GESCHÄFTSFÜHRUNG",
      owner_role: "Geschäftsführer",
      owner_bio: "Führt Talkani seit der Gründung mit klarem Fokus auf Service-Qualität und Kundenzufriedenheit.",
      operations_tag: "BETRIEB",
      operations_role: "Betriebsleitung",
      operations_bio: "Koordiniert Aufträge, Touren und Kundenkommunikation — Ihre erste Ansprechpartnerin.",
      logistics_tag: "LOGISTIK",
      logistics_role: "Teamleitung Logistik",
      logistics_bio: "Leitet die Fahrer-Crew und sorgt für pünktliche, zuverlässige Lieferungen — bundesweit.",
      cleaning_tag: "REINIGUNG",
      cleaning_role: "Teamleitung Reinigung",
      cleaning_bio: "Führt das Reinigungsteam mit höchsten Standards für Büros, Gebäude und Privathaushalte."
    },
    service_area: {
      eyebrow: "EINSATZGEBIET",
      title: "Hamburg & ganz Deutschland.",
      subtitle: "Unser Stammsitz ist Hamburg — wir bedienen die gesamte Metropolregion und realisieren auf Anfrage Aufträge bundesweit.",
      hq_tag: "HAUPTSITZ",
      feature_1: "24/7-Service in der Metropolregion Hamburg",
      feature_2: "Express-Lieferungen in Norddeutschland am selben Tag",
      feature_3: "Bundesweite Umzüge und Logistik auf Anfrage",
      cities_label: "Bedienen wir u.a.",
      city_hamburg: "Hamburg",
      city_bremen: "Bremen",
      city_hannover: "Hannover",
      city_berlin: "Berlin",
      city_luebeck: "Lübeck",
      city_kiel: "Kiel",
      city_rostock: "Rostock",
      city_leipzig: "Leipzig",
      city_duesseldorf: "Düsseldorf",
      city_frankfurt: "Frankfurt",
      city_muenchen: "München",
      city_stuttgart: "Stuttgart"
    },
    live_activity: {
      label: "AKTIVITÄT",
      template: "{activity} · {city} · vor {mins} Min.",
      activities: [
        "Gerade gebucht: Umzug",
        "Gerade gebucht: Regenrinnen-Reinigung",
        "Neue Anfrage: Büroreinigung",
        "Auftrag abgeschlossen: Express-Lieferung",
        "Neue Anfrage: Entrümpelung",
        "Termin bestätigt: Winterdienst",
        "Gerade gebucht: E-Scooter Service"
      ]
    },
    blog: {
      eyebrow: "TALKANI INSIGHTS",
      page_title: "Ratgeber für Logistik, Umzug & Reinigung.",
      page_subtitle: "Echte Tipps aus über tausend Aufträgen — verständlich erklärt, ohne Marketing-Geschwafel.",
      min_read: "Min. Lesezeit",
      read_more: "Weiterlesen",
      back_to_blog: "Zurück zur Übersicht",
      related: "Weitere Artikel",
      empty: "Noch keine Artikel veröffentlicht.",
      not_found: "Artikel nicht gefunden.",
      cta_eyebrow: "BEREIT FÜR IHREN AUFTRAG?",
      cta_title: "Lassen Sie uns über Ihr Projekt sprechen.",
      cta_subtitle: "Holen Sie sich in 60 Sekunden ein unverbindliches Angebot von Talkani."
    },
    pwa: {
      label: "TALKANI APP",
      title: "Installieren Sie Talkani auf Ihrem Gerät.",
      body: "Schnellerer Zugriff, Buchung mit einem Tap, und benachrichtigt bei wichtigen Updates — direkt vom Startbildschirm.",
      install_btn: "Jetzt installieren",
      ios_hint: "iOS: Tippen Sie unten auf das Teilen-Symbol und wählen Sie „Zum Home-Bildschirm hinzufügen\"."
    },
    common: { loading: "Lädt..." },
    vcard: { save_contact: "Als Kontakt speichern", saved: "Im Adressbuch gespeichert!" },
    umzug_calc: {
      eyebrow: "UMZUGS-RECHNER",
      title: "Sofort-Preisangebot für Ihren Umzug.",
      subtitle: "Beantworten Sie 4 Fragen — wir berechnen einen Festpreis-Rahmen mit allen Add-ons. 100 % unverbindlich.",
      rooms: "Anzahl Zimmer",
      rooms_1: "1 Zimmer",
      rooms_2: "2 Zimmer",
      rooms_3: "3 Zimmer",
      rooms_4: "4+ Zimmer",
      floor: "Etage",
      elevator: "Aufzug vorhanden?",
      yes: "Ja",
      no: "Nein",
      distance: "Entfernung",
      distance_city: "Innerhalb Hamburg",
      distance_regional: "Norddeutschland",
      distance_national: "Bundesweit",
      addons: "Zusatzleistungen",
      addon_cleaning: "Endreinigung",
      addon_cleaning_desc: "Besenrein, übergabefertig",
      addon_painting: "Malerarbeiten",
      addon_painting_desc: "Wände streichen & Reparaturen",
      addon_packing: "Verpackung",
      addon_packing_desc: "Kartons und Material inklusive",
      result_title: "Ihre Kalkulation",
      base_price: "Grundpreis",
      add_services: "Zusatzleistungen",
      combo_discount: "Kombi-Rabatt (20 %)",
      from_label: "Ab Preis",
      note: "Unverbindliche Schätzung — Endpreis nach Besichtigung oder Telefonat.",
      cta: "Jetzt Umzug buchen"
    },
    autoteile_story: {
      eyebrow: "Autoteile-Lieferung — So arbeiten wir",
      title: "Vom Lager zur Werkstatt — in 90 Minuten.",
      subtitle: "Ein transparenter Blick auf unseren Autoteile-Express in Hamburg: zuverlässig, dokumentiert und immer pünktlich.",
      steps: [
        {
          n: "01",
          label: "Sicher kommissioniert",
          title: "Aus dem Lager — fehlerfrei verpackt.",
          body: "Wir holen Ihre Teile direkt vom Großhändler ab, prüfen Bestellnummer und Stückzahl und verpacken alles in stabile, neutrale Versandkartons. Jede Sendung wird beim Anheben gescannt — Sie sehen den Status live in unserer App."
        },
        {
          n: "02",
          label: "Unterwegs in Hamburg",
          title: "Express-Zustellung, GPS-getrackt.",
          body: "Mit unserem Sprinter rollen wir mehrmals täglich durch Hamburg. Tour-Optimierung sorgt dafür, dass Ihre Bestellung auf direktem Weg zu Ihnen kommt — auch in der Rushhour. Express in unter 90 Minuten möglich."
        },
        {
          n: "03",
          label: "Übergabe in der Werkstatt",
          title: "Geliefert — direkt an die Hebebühne.",
          body: "Wir kommen bis zum Tresen oder direkt zur Hebebühne, übergeben das versiegelte Paket persönlich und nehmen Altteile zur Entsorgung gleich mit. Lieferschein unterschrieben — und es kann weitergehen."
        }
      ],
      cta: "Werkstatt-Konditionen anfragen"
    },
    subscription: {
      eyebrow: "TALKANI PLUS — ABONNEMENT",
      title: "Saubere Räume, jede Woche neu.",
      subtitle: "Wählen Sie einen Tarif und genießen Sie regelmäßige Reinigung mit garantierten Festpreisen, Priorität bei der Terminvergabe und ohne Aufwand.",
      most_popular: "Beliebteste Wahl",
      footnote: "Alle Tarife: monatlich kündbar · keine versteckten Gebühren · MwSt. inklusive · voll absetzbar als haushaltsnahe Dienstleistung.",
      plans: {
        basic: {
          name: "Talkani Basic",
          tagline: "Monatliche Wartung für kleine Wohnungen.",
          price: "129",
          period: "/Monat",
          frequency: "1× pro Monat · 2 Std.",
          features: ["Vollständige Wohnungsreinigung", "Bad & Küche detailliert", "Reinigungsmittel inklusive", "Feste/r Reinigungspartner/in"],
          cta: "Basic wählen"
        },
        plus: {
          name: "Talkani Plus",
          tagline: "Empfohlen — perfekt für Familien & Berufstätige.",
          price: "279",
          period: "/Monat",
          frequency: "2× pro Monat · 3 Std.",
          features: ["Alles aus Basic", "Fensterreinigung innen", "Kühlschrank & Backofen monatlich", "Priorisierte Terminvergabe", "Schlüsselverwaltung inkl."],
          cta: "Plus wählen"
        },
        premium: {
          name: "Talkani Premium",
          tagline: "Für Häuser, Praxen und Büros.",
          price: "649",
          period: "/Monat",
          frequency: "Wöchentlich · 3 Std.",
          features: ["Alles aus Plus", "Wöchentliche Tiefenreinigung", "Glasflächen innen + außen", "Vor Ort-Manager als Ansprechpartner", "Saisonale Sonderreinigung gratis"],
          cta: "Premium wählen"
        },
        combo: {
          name: "Garten + Haus Combo",
          tagline: "Bestes Preis-Leistungs-Verhältnis — Garten & Haus aus einer Hand.",
          price: "399",
          period: "/Monat",
          frequency: "Garten wöchentlich · Haus alle 2 Wochen",
          features: [
            "Wöchentliche Gartenpflege (Rasen, Hecke, Laub)",
            "Hausreinigung alle 2 Wochen · 3 Std.",
            "Grünschnitt-Entsorgung bis 1 m³ inkl.",
            "Festes Team, feste Wochentage",
            "Pause/Anpassung jederzeit möglich",
            "Spart ~75 € im Vergleich zu Einzelbuchungen"
          ],
          cta: "Combo wählen",
          badge: "BESTES PAKET"
        }
      }
    },
    districts: {
      eyebrow: "SERVICEGEBIET · NORDDEUTSCHLAND",
      title: "Wir liefern in Hamburg — und weit darüber hinaus.",
      subtitle: "Geschätzte Ankunftszeiten ab unserer Zentrale in Wandsbek. Wir fahren täglich Hamburg-Stadt, Umland und die norddeutschen Metropolen — Lübeck, Bremen, Kiel, Hannover.",
      filter_all: "Alle Regionen",
      filter_hamburg: "Hamburg-Stadt",
      filter_umland: "Metropolregion",
      filter_norddeutschland: "Norddeutschland",
      filter_express: "Nur Express (≤ 22 min)",
      footnote: "Ankunftszeiten sind Schätzwerte. Verbindlicher Termin nach Buchung."
    },
    gallery: {
      eyebrow: "VORHER · NACHHER",
      title: "Echte Ergebnisse aus unseren Aufträgen.",
      subtitle: "Direkt von unseren Teams dokumentiert — vor und nach dem Einsatz. Keine Stock-Fotos.",
      before: "Vorher",
      after: "Nachher"
    },
    track: {
      eyebrow: "AUFTRAGSVERFOLGUNG",
      title: "Status Ihres Auftrags",
      subtitle: "Geben Sie Ihre Buchungs-ID ein. Für vollständige Details geben Sie zusätzlich Ihre E-Mail-Adresse an.",
      back: "Zurück zur Startseite",
      booking_id: "Buchungs-ID",
      email_optional: "E-Mail (optional)",
      track_btn: "Verfolgen",
      status: "Aktueller Status",
      date: "Termin",
      address: "Adresse",
      phone: "Telefon",
      customer: "Kunde",
      email_hint: "Geben Sie Ihre E-Mail an, um Adresse, Telefon und Details zu sehen.",
      error_generic: "Konnte nicht laden. Bitte ID prüfen."
    },
    languages_we_speak: {
      eyebrow: "WIR SPRECHEN IHRE SPRACHE",
      title: "5 Sprachen, ein Team.",
      subtitle: "Unser Team berät und betreut Sie in fünf Sprachen — persönlich am Telefon, vor Ort und im Live-Chat."
    },
    faq: {
      eyebrow: "HÄUFIGE FRAGEN",
      title: "Antworten, schnell und ehrlich.",
      subtitle: "Sie haben eine Frage? Wahrscheinlich finden Sie hier die Antwort. Wenn nicht — rufen Sie uns an, wir sind erreichbar.",
      help_title: "Frage nicht dabei?",
      help_body: "Rufen Sie uns einfach an oder schreiben Sie eine E-Mail. Wir antworten meist binnen 1 Stunde während der Geschäftszeiten."
    },
    case_studies: {
      hero_kpi_label: "Ergebnisse in Zahlen",
      hero_kpi1_value: "40%",
      hero_kpi1_sub: "weniger Ausfallzeit für Werkstätten",
      hero_kpi2_value: "6 Std.",
      hero_kpi2_sub: "Express-Umzug inkl. Endreinigung",
      hero_kpi3_value: "14 Monate",
      hero_kpi3_sub: "Ø B2B-Vertragslaufzeit",
      hero_kpi4_value: "100%",
      hero_kpi4_sub: "Versicherungs-Akzeptanz mit Video-Doku",
      back_home: "Zurück zur Startseite",
      eyebrow: "ECHTE AUFTRÄGE",
      title: "So sieht Talkani in der Praxis aus.",
      subtitle: "Drei reale Projekte aus den letzten Monaten — mit echten Kosten, echten Herausforderungen und echten Ergebnissen. Klicken Sie für die vollständige Story.",
      challenge_label: "Herausforderung",
      solution_label: "Unsere Lösung",
      outcome_label: "Ergebnis",
      investment: "Investition",
      read_full: "Vollständige Story",
      book_similar: "Ähnliches buchen"
    },
    certifications: {
      eyebrow: "GEPRÜFT & ZERTIFIZIERT",
      title: "Deutsche Standards, ohne Kompromisse."
    },
    google_reviews: {
      eyebrow: "BEWERTUNGEN",
      title: "Was unsere Kunden auf Google sagen.",
      subtitle: "Verifizierte Bewertungen unserer Kunden — direkt nach jedem Auftrag eingeholt, ungeschönt und transparent.",
      google_label: "Bewertungen",
      based_on: "Basierend auf {n} Bewertungen",
      based_on_one: "Basierend auf {n} Bewertung",
      view_on_google: "Auf Google ansehen",
      empty: "Noch keine Bewertungen — wir freuen uns über Ihr Feedback nach dem ersten Auftrag."
    },
    today_counter: {
      title: "Live · Heute aktiv",
      today_label: "Buchungen heute",
      km_label: "km gefahren",
      co2_label: "kg CO₂ gespart"
    },
    exit_intent: {
      eyebrow: "Warten Sie!",
      title: "15 € Rabatt für Sie.",
      subtitle: "Buchen Sie heute Ihren ersten Service und sparen Sie 15 € — gilt für alle Talkani-Dienstleistungen.",
      your_code: "Ihr persönlicher Code",
      copy: "Kopieren",
      copied: "Kopiert!",
      cta: "Jetzt mit Rabatt buchen",
      note: "Gültig 24 Stunden, einmalig pro Person",
      discount_label: "Rabatt"
    },
    sticky_cta: {
      title: "Bereit für Ihren Auftrag?",
      subtitle: "Online buchen in unter 60 Sekunden — Festpreis-Garantie",
      book_now: "Jetzt buchen"
    },
    mobile_call: {
      label: "Jetzt anrufen"
    },
    plz_checker: {
      eyebrow: "POSTLEITZAHL PRÜFEN",
      title: "Beliefern wir Ihre Region?",
      subtitle: "Geben Sie Ihre deutsche PLZ ein und wir prüfen sofort, ob wir Sie beliefern — inklusive geschätzter Entfernung und Lieferzeit.",
      label: "Ihre Postleitzahl (PLZ)",
      placeholder: "z. B. 22047",
      check_btn: "Prüfen",
      checking: "Prüfe…",
      covered_yes: "Ja! Wir beliefern {city}.",
      distance: "Ca. {km} km · Fahrzeit etwa {min} Minuten",
      express_available: "Express verfügbar",
      express: "Express",
      book_now: "Jetzt buchen",
      covered_no_title: "Aktuell nicht im Standard-Gebiet",
      covered_no_body: "Wir kommen aktuell nicht regulär in diese Region. Auf Anfrage prüfen wir gerne einen individuellen Einsatz für Sie.",
      contact_us: "Anfrage senden",
      error_format: "Bitte geben Sie eine gültige 5-stellige deutsche PLZ ein.",
      error_generic: "Konnte nicht prüfen, bitte später erneut versuchen."
    },
    referral: {
      eyebrow: "TALKANI EMPFEHLUNGSPROGRAMM",
      title: "Empfehlen Sie uns — beide bekommen {eur} €.",
      subtitle: "Teilen Sie Ihren Code mit Freunden und Familie. Bei jeder ersten Buchung Ihres Empfehlungspartners bekommen Sie und er jeweils 20 € Guthaben für Ihre nächsten Aufträge.",
      your_code: "Ihr Empfehlungscode",
      copy_code: "Kopieren",
      copied: "Kopiert!",
      share_whatsapp: "WhatsApp",
      share_email: "E-Mail",
      share_copy: "Nachricht kopieren",
      email_subject: "Sparen Sie 20 € bei Talkani",
      stat_invites: "Einladungen",
      stat_redeemed: "Eingelöst",
      stat_earned: "Verdient",
      footnote: "Sie bekommen {eur} € pro erfolgreicher Empfehlung — auf das nächste Buchungsguthaben anrechenbar."
    },
    chat: {
      open: "Live-Chat öffnen",
      teaser_msg: "Hallo 👋 Brauchen Sie ein schnelles Angebot oder eine Frage? Wir sind hier.",      contextual_teasers: {
        default: "Hallo 👋 Brauchen Sie ein schnelles Angebot oder eine Frage? Wir sind hier.",
        book: "Bereit zu buchen? 📅 Ich helfe Ihnen gerne, den passenden Termin zu finden.",
        track: "Fragen zu Ihrer Lieferung? 📦 Wir helfen sofort weiter.",
        price: "Brauchen Sie einen Festpreis? 💶 Schreiben Sie uns — wir antworten in Minuten.",
        autoteile: "Sie suchen einen Werkstatt-Lieferpartner? 🔧 Express in 90 Minuten möglich.",
        umzug: "Umzug geplant? 📦 Holen Sie sich ein kostenloses Angebot innerhalb von 24 Std.",
        hausreinigung: "Möchten Sie wöchentlich oder einmalig reinigen lassen? 🧹 Wir machen es passend.",
        gartenpflege: "Bereit für die nächste Saison? 🌿 Wir kümmern uns um Ihren Garten — fragen Sie an.",
        reinigung: "Brauchen Sie regelmäßige Büro- oder Gebäudereinigung? ✨ Wir stellen ein Konzept zusammen.",
        dashboard: "Willkommen zurück! 👋 Möchten Sie einen weiteren Auftrag buchen oder einen Status prüfen?",
        booking_success: "Danke für Ihre Buchung! 🎉 Fragen zum Ablauf? Wir sind da.",
        blog: "Sie möchten mehr erfahren? 📖 Fragen Sie uns direkt — gerne mit konkretem Anliegen.",
        login: "Probleme beim Login? 🔐 Schreiben Sie uns — wir helfen sofort.",
        services: "Welche Leistung passt zu Ihnen? 🛠️ Ich berate Sie gerne — kostenlos.",
        contact: "Lieber direkt chatten statt Formular? 💬 Wir antworten in Minuten.",
        about: "Mehr über Talkani erfahren? 👥 Stellen Sie Ihre Frage — wir antworten persönlich.",
        plakatservice: "Werbeagentur oder Veranstalter? 📋 Wir wechseln Ihre Plakate termingerecht — mit Foto-Nachweis."
      },
      close: "Chat schließen",
      header_title: "Talkani Live-Chat",
      header_subtitle: "Sofort-Antwort · AI-Assistent + Team",
      form_intro: "Stellen Sie Ihre Frage — unser AI-Assistent antwortet sofort. Bei Bedarf übernimmt unser Team persönlich.",
      field_name: "Name",
      field_name_placeholder: "Vor- und Nachname",
      field_email: "E-Mail",
      field_email_placeholder: "name@beispiel.de",
      field_message: "Ihre Nachricht",
      field_message_placeholder: "Wie können wir Ihnen helfen?",
      start_btn: "Chat starten",
      starting: "Wird gestartet…",
      send: "Senden",
      input_placeholder: "Nachricht schreiben…",
      ai_label: "Talkani Assistent",
      you_label: "Sie",
      admin_label: "Talkani Team",
      privacy_note: "Mit dem Start akzeptieren Sie unsere Datenschutzerklärung. Wir verwenden Ihre Daten ausschließlich für die Anfragebearbeitung.",
      error_required: "Bitte alle Felder ausfüllen.",
      error_generic: "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      loading: "Wird geladen…",
      closed_msg: "Diese Konversation wurde beendet.",
      start_new: "Neue Konversation starten",
      admin_title: "Live-Chat Nachrichten",
      admin_refresh: "Aktualisieren",
      admin_empty: "Noch keine Konversationen.",
      admin_select: "Wählen Sie links eine Konversation aus.",
      admin_status_open: "Offen",
      admin_status_closed: "Geschlossen",
      admin_close: "Schließen",
      admin_reopen: "Wieder öffnen",
      admin_reply_placeholder: "Antwort schreiben…",
      admin_you: "Sie (Team)",
      admin_closed_ok: "Konversation geschlossen.",
      admin_reopened_ok: "Konversation wieder geöffnet.",
      book_cta: "Jetzt buchen",
      enable_notifications: "Benachrichtigungen aktivieren"
    }
  },
  en: {
    nav: { home: "Home", services: "Services", about: "About", contact: "Contact", dashboard: "My Account", admin: "Admin", login: "Sign In", logout: "Sign Out", book: "Book Now", blog: "Blog", b2b: "Business" },
    trusted_by: {
      label: "Already working for",
      subtitle: "Recurring contracts with workshops & shared-mobility operators in Northern Germany.",
      and_more: "+ All case studies"
    },
    b2b_banner: {
      eyebrow: "Your Business Partner",
      title: "Talkani works for your company.",
      subtitle: "Workshops, ad agencies, property managers, schools, hotels and online shops across Hamburg trust us with their daily deliveries, cleanings and transport runs — with a single monthly invoice, dedicated contacts and up to 15% volume discount.",
      cta_primary: "Book as a company",
      cta_secondary: "For developers: API docs",
      industries_label: "We work for:",
      ind_werkstatt: "Auto workshops",
      ind_agentur: "Ad agencies",
      ind_hausverwaltung: "Property managers",
      ind_hotel: "Hotels & hospitality",
      ind_schule: "Schools & authorities",
      ind_shop: "Online shops",
      stat1: "1 invoice per month",
      stat1_sub: "Instead of many",
      stat2: "Automatable",
      stat2_sub: "Connect your ERP",
      stat3: "up to 15% off",
      stat3_sub: "from 25 orders/month",
      stat4: "90-min guarantee",
      stat4_sub: "Express by contract",
    },
    b2b_lead: {
      eyebrow: "Request a quote",
      title: "Get a business offer in 15 minutes.",
      subtitle: "Fill in 5 fields — we get back to you within 24 hours with a personal offer including volume discount and dedicated contact.",
      f_company: "Company name",
      f_company_ph: "e.g. Sample Workshop Ltd.",
      f_name: "Contact person",
      f_name_ph: "First and last name",
      f_email: "Email",
      f_email_ph: "you@company.com",
      f_phone: "Phone (optional)",
      f_phone_ph: "+49 175 …",
      f_volume: "Expected volume",
      f_volume_help: "Approx. number of orders per month",
      vol_under_10: "under 10/month",
      vol_10_25: "10–25/month",
      vol_25_100: "25–100/month",
      vol_100_plus: "100+/month",
      f_interest: "Interested in",
      int_lieferung: "Deliveries & courier",
      int_autoteile: "Auto-parts to workshops",
      int_reinigung: "Cleaning (property / office / final)",
      int_umzug: "Moves",
      int_escooter: "E-scooter service",
      int_plakatservice: "Poster service / OoH",
      int_gartenpflege: "Gardening & winter service",
      int_other: "Other",
      f_message: "Short description (optional)",
      f_message_ph: "What do you need regularly? Where? When?",
      submit: "Request a quote",
      sending: "Sending…",
      success_title: "Thanks — we'll be in touch within 24 h.",
      success_body: "Your request has reached us. You'll receive a confirmation email shortly.",
      error_generic: "Something went wrong. Please try again or call +49 175 8802646.",
      required: "Please fill in all required fields."
    },
    b2b: {
      meta_title: "Talkani B2B — Business Customers | Consolidated Invoicing · API · SLA",
      meta_desc: "Logistics & services for workshops, ad agencies, property managers, schools, hotels & online shops. Monthly consolidated invoicing, API integration and guaranteed express SLA.",
      hero_eyebrow: "Talkani Business",
      hero_title_line1: "Logistics that carry",
      hero_title_line2: "your daily business.",
      hero_subtitle: "For workshops, ad agencies, property managers, schools, hotels and online shops with recurring needs — with monthly consolidated invoicing, API integration and a dedicated account manager.",
      hero_cta_call: "Request consultation",
      hero_cta_api: "View API",
      hero_cta_trial: "Start a trial booking",
      segments_eyebrow: "For whom?",
      segments_title: "Your industry, our service.",
      seg_werkstatt_label: "Auto workshops",
      seg_werkstatt_text: "Express auto-parts delivery from wholesaler to workshop in 90 min. Daily & weekly contracts.",
      seg_werkstatt_case1: "Brakes / filters / batteries",
      seg_werkstatt_case2: "Same-day express",
      seg_werkstatt_case3: "20% contract discount",
      seg_werbung_label: "Ad agencies & OoH",
      seg_werbung_text: "Poster changes (city-light posters, billboards, advertising columns) reliably across northern Germany.",
      seg_werbung_case1: "CLP changes at bus stops",
      seg_werbung_case2: "Construction-fence stickers",
      seg_werbung_case3: "Photo proof for every site",
      seg_hv_label: "Property managers",
      seg_hv_text: "Stairwell cleaning, gutters, garden care and winter service for entire property portfolios.",
      seg_hv_case1: "Weekly cleaning",
      seg_hv_case2: "Seasonal contracts",
      seg_hv_case3: "24/7 emergency service",
      seg_schule_label: "Schools & authorities",
      seg_schule_text: "Cleaning and logistics for public institutions — VOL/A-compliant with public-tender experience.",
      seg_schule_case1: "School & Kita cleaning",
      seg_schule_case2: "Universities & agencies",
      seg_schule_case3: "Security-vetted staff",
      seg_hotel_label: "Hotels & hospitality",
      seg_hotel_text: "Day-rate cleaning staff, laundry logistics, façade and window cleaning.",
      seg_hotel_case1: "Room cleaning",
      seg_hotel_case2: "Banquet rooms",
      seg_hotel_case3: "Exteriors & signage",
      seg_shop_label: "Online shops",
      seg_shop_text: "Same-day delivery for Hamburg & surroundings. Urgent shipments, bulky goods, returns.",
      seg_shop_case1: "Same-day in 4h",
      seg_shop_case2: "Bulky goods up to 2 m³",
      seg_shop_case3: "Photo proof on delivery",
      features_eyebrow: "What you get",
      features_title: "6 reasons for Talkani Business.",
      f_invoice_title: "Consolidated invoicing",
      f_invoice_text: "One invoice per month — DATEV-compatible, sent automatically.",
      f_api_title: "API & webhooks",
      f_api_text: "Integrate Talkani directly into your ERP / WMS (REST + webhooks).",
      f_sla_title: "Express SLA",
      f_sla_text: "Guaranteed 90-min response time — contractually committed.",
      f_account_title: "Account manager",
      f_account_text: "A dedicated contact person for all matters.",
      f_gdpr_title: "GDPR & DPA",
      f_gdpr_text: "Data processing agreement on request. Fully GDPR-compliant.",
      f_scale_title: "Scalable",
      f_scale_text: "From 5 to 5,000 jobs per month. Fair volume discounts.",
      api_badge: "Developer interface",
      api_title: "Integrate Talkani in 1 day.",
      api_intro_pre: "If your ERP, workshop system or dispatch software already speaks REST, you can connect Talkani in ",
      api_intro_strong: "less than 8 hours",
      api_intro_post: ". No licence fees — you only pay for executed jobs.",
      api_b1_b: "OpenAPI 3.1",
      api_b1: " — Interactive Swagger docs, tested with every HTTP client",
      api_b2_b: "JSON in → JSON out",
      api_b2: " — No SOAP pain, no XML hocus-pocus",
      api_b3_b: "Webhooks",
      api_b3: " — Status updates pushed to your endpoint, no polling needed",
      api_b4_b: "Sandbox + production",
      api_b4: " — Test in a separate environment, go live when you're ready",
      api_b5_b: "Code samples",
      api_b5: " — cURL, Python, Node.js, PHP — copyable directly from the docs",
      api_open_docs: "Open API documentation",
      api_request_key: "Request partner key",
      api_code_response: "# Response",
      steps_eyebrow: "In 4 steps",
      steps_title: "How you go live.",
      step1_title: "1. Read the documentation",
      step1_text: "Open /api/docs — a full, interactive OpenAPI spec of every endpoint.",
      step2_title: "2. Request a partner key",
      step2_text: "Email info@talkani.de — we send you an API token + DPA draft.",
      step3_title: "3. Integrate",
      step3_text: "REST calls directly from your ERP / dispatch system. JSON in, JSON out.",
      step4_title: "4. Receive webhooks",
      step4_text: "Status changes (received → confirmed → on-route → completed) land automatically in your system.",
      pricing_eyebrow: "Volume discounts",
      pricing_title: "Fairly scaled with your volume.",
      tier_starter: "Starter",
      tier_starter_jobs: "up to 25 / month",
      tier_starter_rabatt: "0%",
      tier_growth: "Growth",
      tier_growth_jobs: "25 – 100 / month",
      tier_growth_rabatt: "8%",
      tier_enterprise: "Enterprise",
      tier_enterprise_jobs: "100+ / month",
      tier_enterprise_rabatt: "custom",
      tier_discount_label: "Volume discount",
      tier_f1: "Consolidated invoicing",
      tier_f2: "Account manager",
      tier_f3: "Express SLA",
      tier_f4: "API access",
      final_cta_title: "Book a conversation.",
      final_cta_text: "In 15 minutes we'll discuss your needs and create a custom offer.",
    },
    hero: {
      eyebrow: "TALKANI GMBH · LOGISTICS · CLEANING · SERVICE FOR BUSINESS",
      title: "Fast. Reliable. Flexible.",
      subtitle: "Your logistics and cleaning partner in Hamburg — parcel deliveries, auto-parts distribution, 2 Man Handling with furniture assembly, cleaning for property managers and hotels, moves and the overnight e-scooter service for shared-mobility operators. We work for workshops, online shops, companies and private households across Hamburg and Northern Germany.",
      cta_primary: "Book a Service",
      cta_secondary: "View Services"
    },
    about_intro: {
      eyebrow: "ABOUT US",
      title: "More than just logistics.",
      body: "Talkani is a modern service company for logistics, cleaning, and service. We handle reliable transport and on-time delivery of parcels, food, medicines, baked goods, flowers, and other sensitive or time-critical shipments. As a flexible service company, we are open to individual requests — simply talk to us and we'll develop a tailored solution.",
      stat1_value: "10+",
      stat1_label: "Services",
      stat2_value: "24/7",
      stat2_label: "Availability",
      stat3_value: "100%",
      stat3_label: "Reliability"
    },
    services: {
      eyebrow: "OUR SERVICES",
      title: "Everything from one source.",
      lieferung: { name: "Delivery & Logistics", desc: "Safe and punctual delivery of every type of shipment — we deliver: • Parcels & packages (same-day in Hamburg) • Groceries & shopping (refrigerated on request) • Medication & pharmacy runs • Bakery goods & fresh produce (early morning) • Flowers & sensitive shipments • Documents & express courier • Drinks & bulk purchases. GPS tracking, photo proof on handover and personal drivers — your shipment gets a name, not a tracking code." },
      escooter_service: { name: "E-Scooter Service", desc: "Complete fleet logistics for e-scooter operators — we cover: • Overnight battery charging & swapping • Transport of defective vehicles to the workshop • Distribution of ready-to-ride scooters in hotspot zones • Pickup & delivery between warehouse and city zone • Cleaning & vehicle care • Inventory and location reports. Scalable from 50 to 5,000 vehicles — for sharing services in Hamburg and across northern Germany." },
      umzug: { name: "Moving, Clearance, Cleaning & Painting", desc: "Your complete move from a single provider — we handle: • Furniture transport with padded loading • Packing with boxes & materials • Furniture assembly & disassembly (incl. IKEA) • Clearance of apartment, basement and attic • Thorough final cleaning (broom-clean to mirror-shine) • Painting work (walls, repairs, renovation) • Piano transport & specialty furniture. Fixed-price guarantee, no hidden costs, one contact for everything." },
      reinigung: { name: "Cleaning (All Types)", desc: "Professional cleaning for all buildings and spaces — we cover: • Stairwell cleaning (property managers / apartment blocks) • Window & glass cleaning (interior & exterior, including upper floors) • Office & medical-practice cleaning • Government offices, universities, schools, kindergartens & training centers • Hotels, retail spaces, practices & shops • Trash-room and courtyard cleaning • Graffiti removal (façades, garage doors, shop windows — gentle methods without damaging the substrate) • Deep cleaning & post-construction cleaning. Professional equipment, trained staff — on request after business hours or as a recurring maintenance contract." },
      hausreinigung: { name: "House Cleaning & Private Households", desc: "Recurring or one-time cleaning of your home — we clean: • Living and bedrooms • Kitchen (countertops, appliances, cabinets exterior) • Bathrooms (sanitary, tiles, mirrors) • Windows, doors & floors • Dusting & cobweb removal • Trash disposal & bed linen change (on request). Our own eco-friendly supplies, discreet and conscientious staff — weekly, bi-weekly or monthly. Perfect for families, busy professionals and seniors." },
      gartenpflege: { name: "Garden Care & Cleanup", desc: "Full garden care, season by season — we handle: • Lawn mowing, scarifying & fertilising • Hedge and shrub trimming (all heights) • Weed removal (mechanical & thermal) • Path, patio and pavement cleaning • Leaf removal & disposal • Spring and autumn cleanup • Tree care & storm damage cleanup • Grave care & cemetery planting. Recurring (weekly, bi-weekly, monthly) for private gardens, apartment buildings and commercial properties." },
      autoteile: { name: "Auto Parts Delivery to Workshops", desc: "Fast workshop logistics across Hamburg and surroundings — we deliver: • Brakes, filters & wear parts • Batteries, alternators & starters • Mirrors, glass & body parts • Oils, lubricants & operating fluids • Tools & consumables • Tyres & wheels (incl. seasonal pickup). Multiple times daily, same-day or express in 90 minutes. B2B framework contracts with monthly consolidated invoicing." },
      regenrinne_reinigung: { name: "Pipe & Gutter Cleaning with Camera", desc: "Professional cleaning with full transparency — our service includes: • Cleaning of roof gutters & downpipes • Interior inspection with sewer camera (endoscope) • High-pressure flushing of drain lines • Full video documentation • Before/after photos of every component • Recommendation for maintenance intervals. Also for apartment buildings, commercial properties and property managers — with detailed report for your records." },
      winterdienst: { name: "Winter Service & Snow Removal", desc: "Statutory clearing & gritting duty fulfilled professionally — we cover: • Snow removal for sidewalks, driveways & courtyards • Gritting with salt or eco-friendly granulate • Clearing of streets, parking lots & commercial areas • 24/7 standby during snowfall • Seasonal contracts with fixed price (Nov–Mar) • Black-ice control & ice breaking. Maximum safety for residents, employees and customers — we take liability for legally compliant clearing." },
      zweimann_handling: { name: "2 Man Handling & furniture assembly", desc: "Reliable 2 Man delivery for heavy shipments and large furniture — we handle: • Sofas, beds & wall units (slip-mats & edge protection) • Washing machines, refrigerators & dishwashers • Kitchen cabinets & full kitchens (connection on request) • Large TVs 65\" and up • Fitness equipment & massage chairs • Up to 4th floor without lift, with lift all floors • Furniture assembly per instructions • Packaging take-back & old-appliance disposal (EAR-registered). Ideal for online shops, property managers and private customers. From €59 Standard · €89 Handling+ · €149 Full-Service." },
      plakatservice: { name: "Poster Service — Outdoor Advertising & Poster Changes", desc: "Professional outdoor-advertising logistics for agencies and event organisers — we offer: • City-Light-Poster (CLP) at bus stops • Billboards (18/1) & Mega-Light • Advertising columns & poster walls • Poster pasting on construction fences • Sticker & decal campaigns • Last-minute swaps & express installs • Photo proof (before/after + GPS per location) • Proper disposal of old posters. Compatible with JCDecaux, Ströer, Wall, Awk and other systems — on time, documented, reliable." }
    },
    specialty: {
      eyebrow: "SPECIALTY DELIVERIES",
      title: "We deliver everything. Safe, fresh, on time.",
      subtitle: "Whatever you need to send — we have the right solution. A few of our specialties:",
      blumen: { name: "Flowers", desc: "Fresh bouquets and plants — carefully wrapped, swiftly delivered. Perfect for birthdays, anniversaries, and special occasions." },
      backwaren: { name: "Baked Goods", desc: "Fresh rolls, croissants, cakes and pastries — straight from the bakery to you or your customers, still warm and fresh." },
      zeitungen: { name: "Newspapers", desc: "Reliable early-morning delivery of daily and weekly newspapers — on time before the first coffee, in any weather." },
      medikamente: { name: "Medicines", desc: "Discreet, secure delivery of pharmacy products and medicines — temperature-controlled and confidential." },
      andere: { name: "Other Service", desc: "Need something not on our list? No problem — just describe what you need and we'll create a custom solution for you." }
    },
    testimonials: {
      eyebrow: "TESTIMONIALS",
      title: "What our customers say.",
      subtitle: "Honest, direct reviews from our real customers.",
      empty_title: "No reviews yet.",
      empty_body: "Be the first! We'd love to hear your feedback after every job.",
      write_btn: "Write a review",
      form_title: "Your review",
      form_name: "Your name (publicly visible)",
      form_role: "Role / Company (optional)",
      form_rating: "Stars",
      form_text: "What do you think about our service?",
      form_submit: "Submit review",
      form_cancel: "Cancel",
      form_login_required: "Please sign in first to submit a review.",
      form_success: "Thank you for your review!"
    },
    values: {
      eyebrow: "WHY TALKANI",
      title: "Values you can rely on.",
      reliability: { title: "Reliability", desc: "On time, careful, professional — every single job." },
      quality: { title: "Quality", desc: "Trained team and efficient processes for the highest quality." },
      flexibility: { title: "Flexibility", desc: "Tailored solutions for individual requirements." },
      satisfaction: { title: "Customer Satisfaction", desc: "Your satisfaction always comes first for us." }
    },
    cta_banner: { title: "Ready to start your job?", subtitle: "Book online in under 60 seconds.", button: "Book Now" },
    contact: {
      eyebrow: "CONTACT",
      title: "Talk to us.",
      name: "Name", email: "Email", phone: "Phone", subject: "Subject", message: "Your message", send: "Send Message",
      sent: "Message sent — we'll be in touch shortly.",
      address_label: "Address", phone_label: "Phone", email_label: "Email"
    },
    footer: { rights: "All rights reserved.", imprint: "Imprint", privacy: "Privacy", agb: "Terms", cookies: "Cookie settings" },
    voice: { title: "Voice Booking · NEW", subtitle: "Speak your request — we'll fill the form automatically.", start: "Start recording", stop: "Done", recording: "Recording…", processing: "Transcribing…", transcript: "Transcript", again: "Try again" },
    text_booking: { title: "Text Booking", subtitle: "Describe your request in words — AI will fill the form automatically.", start: "Type request", submit: "Auto-fill", cancel: "Cancel", processing: "Processing…", placeholder: "e.g. 'I need a 2-room move tomorrow at 2pm from Eimsbüttel to Altona'", error: "No fields detected — please be more specific." },
    auth: {
      sign_in: "Sign in with Google", sign_in_title: "Welcome back", sign_in_subtitle: "Sign in to manage your bookings.",
      create_account: "Create account", create_account_subtitle: "Create your personal Talkani account.",
      tab_signin: "Sign in", tab_register: "Register",
      password: "Password", or: "or",
      sign_in_btn: "Sign in", create_account_btn: "Create account",
      processing: "Signing in...",
      forgot_password: "Forgot password?",
      forgot_title: "Reset Password",
      forgot_subtitle: "Enter your email address. We'll send you a reset link.",
      forgot_submit: "Send reset link",
      forgot_sent_title: "Link sent",
      forgot_sent_body: "If an account with this email exists, we've sent a reset link. Check your spam folder too. The link is valid for 30 minutes.",
      back_to_login: "Back to sign in",
      reset_title: "Set new password",
      reset_subtitle: "Choose a strong new password for your Talkani account.",
      reset_new_password: "New password",
      reset_confirm_password: "Confirm password",
      reset_password_hint: "At least 8 characters. Recommended: letters, numbers, and special characters.",
      reset_password_too_short: "Password must be at least 8 characters.",
      reset_password_mismatch: "Passwords do not match.",
      reset_submit: "Save password",
      reset_success_title: "Password updated",
      reset_success_body: "Your password has been changed. You'll be redirected to sign in shortly.",
      reset_invalid_title: "Invalid link",
      reset_invalid_body: "This reset link is invalid or expired. Please request a new one.",
      reset_invalid_link: "The link is invalid. Please request a new one."
    },
    booking: {
      title: "Book a Service", step: "Step", of: "of",
      step1: "Choose Service", step2: "Date & Time", step3: "Details", step4: "Confirm",
      step1_main: "Main Services", step1_specialty: "Specialty Deliveries",
      date: "Date", time: "Time", name: "Name", email: "Email", address: "Address", phone: "Phone", details: "Additional details (optional)",
      details_custom: "Describe your request",
      details_custom_placeholder: "What would you like delivered / done? Please describe briefly.",
      back: "Back", next: "Next", confirm: "Confirm Booking", success: "Booking confirmed!", success_msg: "We'll send you a confirmation by email.",
      view_bookings: "View My Bookings",
      have_code: "Add a referral or discount code",
      referral_code_label: "Referral code",
      discount_code_label: "Discount code",
      referral_valid: "Code from {name} valid — you save {eur} €",
      referral_invalid: "Code invalid or expired.",
      code_note: "Both codes are optional. We'll calculate the final price and apply the discount before confirmation."
    },
    dashboard: {
      title: "My Bookings", new_booking: "New Booking", empty: "You have no bookings yet.", book_now: "Book Now",
      status: { pending: "Pending", confirmed: "Confirmed", in_progress: "In Progress", completed: "Completed", cancelled: "Cancelled" }
    },
        admin_analytics: { eyebrow: "Analytics", title: "Bookings Analytics", subtitle: "Weekly view: confirmed vs. cancelled per service.", weekly_title: "Weekly trend", by_service_title: "Bookings by service" },
    cookie_consent: {
      aria_label: "Cookie settings",
      banner_title: "We respect your privacy.",
      banner_body: "We use essential cookies for the site. With your consent we would also like to use anonymous usage analytics and marketing cookies. You can withdraw consent at any time.",
      privacy_link: "Privacy policy",
      imprint_link: "Imprint",
      accept_all: "Accept all",
      only_necessary: "Only necessary",
      settings: "Settings",
      settings_title: "Cookie settings",
      settings_body: "Choose which cookies we may set. Necessary cookies can't be turned off — without them booking, login and language selection don't work.",
      cat_necessary_title: "Necessary",
      cat_necessary_body: "Required for basic site operation (session handling, booking form, language selection). Without these cookies the site does not work correctly.",
      cat_analytics_title: "Analytics",
      cat_analytics_body: "Anonymous usage stats (which pages are visited, which teasers customers click). We do not build personal profiles.",
      cat_marketing_title: "Marketing",
      cat_marketing_body: "Enables referral codes, campaign tracking and open statistics for email confirmations.",
      item_session: "Session & login (auth_session)",
      item_lang: "Language choice (de / en / ar)",
      item_booking_id: "Active booking ID for tracking",
      item_teasers: "Chat teaser impressions (which contextual teaser was already shown)",
      item_chat_meta: "Anonymous chat conversation metadata (language, timezone)",
      item_referral: "Referral-code tracking (?ref=…)",
      item_email_track: "Email open tracking (booking and status emails)",
      save_selection: "Save selection",
      footer_note: "Your choice is valid for 12 months. You can change it any time under",
    },
    admin_leads: {
      eyebrow: "B2B pipeline",
      title: "Business inquiries",
      subtitle: "Manage all incoming business leads and track them through the pipeline.",
      total: "Total",
      all: "All",
      status_new: "New",
      status_contacted: "Contacted",
      status_qualified: "Qualified",
      status_won: "Won",
      status_lost: "Lost",
      mark_contacted: "Contacted",
      mark_qualified: "Qualify",
      mark_won: "Won",
      mark_lost: "Lost",
      details: "Details",
      hide: "Hide",
      message_label: "Customer message",
      empty: "No leads in this filter yet.",
      status_updated: "Status updated."
    },
    admin: { title: "Admin – All Bookings", customer: "Customer", service: "Service", datetime: "Date/Time", status: "Status", actions: "Actions", update: "Update", confirm: "Confirm", complete: "Complete", cancel: "Cancel", reopen: "Reopen", delete: "Delete", delete_test: "Delete Test Bookings", delete_test_confirm: "Really delete all test/QA bookings (Refactor QA, test_*, example.com)?", delete_confirm: "Really delete this booking?", email_sent: "Customer notified by email" },
    calculator: {
      eyebrow: "PRICE CALCULATOR",
      title: "Instant pricing, no phone call.",
      subtitle: "Get a non-binding price estimate in seconds. Final price is confirmed after a short review.",
      disclaimer: "All prices are non-binding starting estimates. The final price is calculated fairly and transparently after we review your request.",
      tag: "TALKANI CALCULATOR",
      headline: "Calculate your price instantly",
      field_service: "Service",
      field_size: "Scope",
      field_distance: "Distance",
      size_small: "Small",
      size_medium: "Medium",
      size_large: "Large",
      size_small_umzug: "1 Room",
      size_medium_umzug: "2–3 Rooms",
      size_large_umzug: "4+ Rooms",
      size_small_reinigung: "Up to 2h",
      size_medium_reinigung: "3–4 hours",
      size_large_reinigung: "5–8 hours",
      size_small_hausreinigung: "Apartment up to 60 m²",
      size_medium_hausreinigung: "House 60–120 m²",
      size_large_hausreinigung: "House 120+ m²",
      size_small_gartenpflege: "Small up to 100 m²",
      size_medium_gartenpflege: "Medium 100–300 m²",
      size_large_gartenpflege: "Large 300+ m²",
      size_small_autoteile: "Up to 5 parts / run",
      size_medium_autoteile: "Daily contract 5–20 parts",
      size_large_autoteile: "Day rate 20+ / multi-run",
      size_small_regenrinne_reinigung: "Single house",
      size_medium_regenrinne_reinigung: "Duplex",
      size_large_regenrinne_reinigung: "Apartment building",
      size_small_winterdienst: "Single visit",
      size_medium_winterdienst: "Multiple visits",
      size_large_winterdienst: "Seasonal contract",
      result_label: "Your estimate",
      from: "from",
      cta_book: "Book Now",
      cta_contact: "Request quote",
      lieferung_note: "Includes base fee & per-km rate. Express delivery on request.",
      umzug_note: "Includes 2 movers and transport. Packing & clearance optional.",
      reinigung_note: "Minimum 2 hours, including materials and travel within Hamburg area.",
      hausreinigung_note: "Includes our own supplies and travel. Discount when booked weekly or bi-weekly.",
      gartenpflege_note: "Includes equipment and disposal of up to 1 m³ green waste. Seasonal contract: best price year-round.",
      autoteile_note: "Express within 90 min. incl. return of old parts. Daily/weekly contracts with special rates.",
      regenrinne_note: "Includes pipe-camera inspection and video documentation.",
      winterdienst_note: "Per visit including grit. Seasonal contract offers the best price.",
      escooter_note: "For fleet operators: Custom quote based on city, fleet size, and service scope.",
      plakatservice_note: "For ad agencies and event organisers: Custom packages based on format (CLP, billboard, advertising column), number of locations and rotation frequency.",
      you_save: "You save",
      combo_title: "+ End-of-tenancy cleaning",
      combo_badge: "-20%",
      combo_desc: "We clean your old apartment after the move — broom-clean and handover-ready. Save €30 in the bundle."
    },
    before_after: {
      eyebrow: "BEFORE · AFTER",
      title: "See the difference.",
      subtitle: "Drag the slider to reveal the real result. Real examples from our work.",
      disclaimer: "Illustrative images representing typical results. Real references from specific jobs are available on request.",
      regenrinne_title: "Gutter · Clogged → Clean",
      regenrinne_desc: "Full cleaning with camera inspection and video documentation.",
      reinigung_title: "Building cleaning · Before & After",
      reinigung_desc: "Professional cleaning of offices, stairwells, and commercial spaces.",
      entruempelung_title: "Clearance · Full → Empty",
      entruempelung_desc: "Cellars, attics, and apartments — properly cleared and broom-clean."
    },
    trust: {
      eyebrow: "TRUST & QUALITY",
      title: "What you can count on.",
      subtitle: "We operate seriously, transparently, and with real German standards — from insurance to a fixed-price guarantee.",
      insured_title: "Family Business",
      insured_desc: "Personally managed from Hamburg. Insurance coverage is being finalized — current status is shared transparently before any job.",
      gdpr_title: "100% GDPR Compliant",
      gdpr_desc: "Your data stays in Germany. Encrypted transmission, never shared with third parties.",
      hamburg_title: "Hamburg Family Business",
      hamburg_desc: "Talkani — based in Hamburg, family-run business currently in formation.",
      tax_title: "Clean Invoice",
      tax_desc: "Transparent invoice with VAT clearly stated — fully tax-deductible for private and business customers.",
      fixed_price_title: "Fixed-Price Guarantee",
      fixed_price_desc: "What we quote in advance is what you pay. No hidden costs — ever.",
      premium_equipment_title: "Certified Pro Equipment",
      premium_equipment_desc: "We use certified professional equipment (Kärcher, sewer cameras, snow clearing tech) and trained personnel."
    },
    team: {
      eyebrow: "OUR TEAM",
      title: "People who deliver.",
      subtitle: "Behind Talkani stands a coordinated team of logistics, cleaning, and service specialists — all with one goal: your satisfaction.",
      owner_tag: "LEADERSHIP",
      owner_role: "Managing Director",
      owner_bio: "Leads Talkani since founding with a clear focus on service quality and customer satisfaction.",
      operations_tag: "OPERATIONS",
      operations_role: "Operations Manager",
      operations_bio: "Coordinates orders, routes, and customer communication — your first point of contact.",
      logistics_tag: "LOGISTICS",
      logistics_role: "Logistics Team Lead",
      logistics_bio: "Leads the driver crew and ensures punctual, reliable deliveries — nationwide.",
      cleaning_tag: "CLEANING",
      cleaning_role: "Cleaning Team Lead",
      cleaning_bio: "Runs the cleaning team to the highest standards for offices, buildings, and private homes."
    },
    service_area: {
      eyebrow: "SERVICE AREA",
      title: "Hamburg & all of Germany.",
      subtitle: "Our headquarters is Hamburg — we serve the entire metropolitan region and handle nationwide jobs on request.",
      hq_tag: "HEADQUARTERS",
      feature_1: "24/7 service across the Hamburg metropolitan region",
      feature_2: "Same-day express deliveries in Northern Germany",
      feature_3: "Nationwide moves and logistics on request",
      cities_label: "We also cover",
      city_hamburg: "Hamburg",
      city_bremen: "Bremen",
      city_hannover: "Hannover",
      city_berlin: "Berlin",
      city_luebeck: "Lübeck",
      city_kiel: "Kiel",
      city_rostock: "Rostock",
      city_leipzig: "Leipzig",
      city_duesseldorf: "Düsseldorf",
      city_frankfurt: "Frankfurt",
      city_muenchen: "Munich",
      city_stuttgart: "Stuttgart"
    },
    live_activity: {
      label: "LIVE",
      template: "{activity} · {city} · {mins} min ago",
      activities: [
        "Just booked: Moving",
        "Just booked: Gutter Cleaning",
        "New request: Office Cleaning",
        "Order completed: Express Delivery",
        "New request: Clearance",
        "Confirmed: Winter Service",
        "Just booked: E-Scooter Service"
      ]
    },
    blog: {
      eyebrow: "TALKANI INSIGHTS",
      page_title: "Guides for logistics, moving & cleaning.",
      page_subtitle: "Real tips from over a thousand jobs — explained clearly, without marketing fluff.",
      min_read: "min read",
      read_more: "Read more",
      back_to_blog: "Back to blog",
      related: "More articles",
      empty: "No articles published yet.",
      not_found: "Article not found.",
      cta_eyebrow: "READY FOR YOUR JOB?",
      cta_title: "Let's talk about your project.",
      cta_subtitle: "Get a non-binding quote from Talkani in 60 seconds."
    },
    pwa: {
      label: "TALKANI APP",
      title: "Install Talkani on your device.",
      body: "Faster access, one-tap booking, and notifications for important updates — right from your home screen.",
      install_btn: "Install now",
      ios_hint: "iOS: Tap the share icon below and choose \"Add to Home Screen\"."
    },
    common: { loading: "Loading..." },
    vcard: { save_contact: "Save as contact", saved: "Saved to your contacts!" },
    umzug_calc: {
      eyebrow: "MOVING CALCULATOR",
      title: "Instant quote for your move.",
      subtitle: "Answer 4 quick questions — we compute a fixed-price range with all add-ons. 100% non-binding.",
      rooms: "Number of rooms",
      rooms_1: "1 room",
      rooms_2: "2 rooms",
      rooms_3: "3 rooms",
      rooms_4: "4+ rooms",
      floor: "Floor",
      elevator: "Elevator?",
      yes: "Yes",
      no: "No",
      distance: "Distance",
      distance_city: "Within Hamburg",
      distance_regional: "Northern Germany",
      distance_national: "Nationwide",
      addons: "Add-on services",
      addon_cleaning: "Final cleaning",
      addon_cleaning_desc: "Broom-clean, handover-ready",
      addon_painting: "Painting",
      addon_painting_desc: "Wall painting & repairs",
      addon_packing: "Packing",
      addon_packing_desc: "Boxes & materials included",
      result_title: "Your estimate",
      base_price: "Base price",
      add_services: "Add-ons",
      combo_discount: "Combo discount (20%)",
      from_label: "Starting at",
      note: "Non-binding estimate — final price after on-site or phone consultation.",
      cta: "Book the move now"
    },
    autoteile_story: {
      eyebrow: "Auto-Parts Delivery — How we work",
      title: "From warehouse to workshop — in 90 minutes.",
      subtitle: "A transparent look at our auto-parts express in Hamburg: reliable, documented and always on time.",
      steps: [
        {
          n: "01",
          label: "Picked & packed safely",
          title: "From the warehouse — packed without errors.",
          body: "We pick your parts directly from the wholesaler, verify order number and quantity, and pack everything in sturdy neutral shipping cartons. Every parcel is scanned on pickup — you see the live status in our app."
        },
        {
          n: "02",
          label: "On the way through Hamburg",
          title: "Express delivery, GPS-tracked.",
          body: "Our Sprinter runs through Hamburg several times a day. Tour optimisation ensures your order takes the most direct route — even in rush hour. Express in under 90 minutes available."
        },
        {
          n: "03",
          label: "Hand-over at the workshop",
          title: "Delivered — right to the lift.",
          body: "We come to the counter or directly to the lift, hand over the sealed package personally and take old parts away for disposal. Delivery slip signed — and your team gets back to work."
        }
      ],
      cta: "Request workshop pricing"
    },
    subscription: {
      eyebrow: "TALKANI PLUS — SUBSCRIPTION",
      title: "Clean spaces, every week.",
      subtitle: "Pick a plan and enjoy recurring cleaning with guaranteed fixed pricing, priority scheduling, zero hassle.",
      most_popular: "Most popular",
      footnote: "All plans: month-to-month · no hidden fees · VAT included · fully tax-deductible as household service.",
      plans: {
        basic: {
          name: "Talkani Basic",
          tagline: "Monthly maintenance for small apartments.",
          price: "129",
          period: "/month",
          frequency: "1× per month · 2 hrs",
          features: ["Full apartment cleaning", "Bath & kitchen detailed", "Supplies included", "Dedicated cleaning partner"],
          cta: "Choose Basic"
        },
        plus: {
          name: "Talkani Plus",
          tagline: "Recommended — perfect for families & professionals.",
          price: "279",
          period: "/month",
          frequency: "2× per month · 3 hrs",
          features: ["Everything in Basic", "Interior window cleaning", "Fridge & oven monthly", "Priority scheduling", "Key management included"],
          cta: "Choose Plus"
        },
        premium: {
          name: "Talkani Premium",
          tagline: "For houses, clinics and offices.",
          price: "649",
          period: "/month",
          frequency: "Weekly · 3 hrs",
          features: ["Everything in Plus", "Weekly deep cleaning", "Interior + exterior glass", "On-site manager contact", "Seasonal deep clean free"],
          cta: "Choose Premium"
        },
        combo: {
          name: "Garden + Home Combo",
          tagline: "Best value — garden & home from a single provider.",
          price: "399",
          period: "/month",
          frequency: "Garden weekly · Home every 2 weeks",
          features: [
            "Weekly garden care (lawn, hedge, leaves)",
            "Home cleaning every 2 weeks · 3 hrs",
            "Green waste disposal up to 1 m³ included",
            "Same team, same weekday",
            "Pause/adjust anytime",
            "Saves ~€75 vs single bookings"
          ],
          cta: "Choose Combo",
          badge: "BEST VALUE"
        }
      }
    },
    districts: {
      eyebrow: "SERVICE AREA · NORTHERN GERMANY",
      title: "We deliver in Hamburg — and far beyond.",
      subtitle: "Estimated arrival times from our HQ in Wandsbek. We drive Hamburg city, metropolitan region and the northern German metropolises — Lübeck, Bremen, Kiel, Hannover — every day.",
      filter_all: "All regions",
      filter_hamburg: "Hamburg city",
      filter_umland: "Metro region",
      filter_norddeutschland: "Northern Germany",
      filter_express: "Express only (≤ 22 min)",
      footnote: "Arrival times are estimates. Confirmed time after booking."
    },
    gallery: {
      eyebrow: "BEFORE · AFTER",
      title: "Real results from our jobs.",
      subtitle: "Documented directly by our teams — before and after each job. No stock photos.",
      before: "Before",
      after: "After"
    },
    track: {
      eyebrow: "BOOKING TRACKING",
      title: "Status of your booking",
      subtitle: "Enter your booking ID. For full details, also enter the email used when booking.",
      back: "Back to homepage",
      booking_id: "Booking ID",
      email_optional: "Email (optional)",
      track_btn: "Track",
      status: "Current status",
      date: "Appointment",
      address: "Address",
      phone: "Phone",
      customer: "Customer",
      email_hint: "Enter your email to see address, phone and details.",
      error_generic: "Could not load. Please check the ID."
    },
    languages_we_speak: {
      eyebrow: "WE SPEAK YOUR LANGUAGE",
      title: "5 languages, one team.",
      subtitle: "Our team advises and supports you in five languages — by phone, on site, and in the live chat."
    },
    faq: {
      eyebrow: "FREQUENTLY ASKED",
      title: "Answers, fast and honest.",
      subtitle: "Got a question? You'll probably find the answer here. If not — just call us, we pick up.",
      help_title: "Question not listed?",
      help_body: "Give us a call or send an email. We usually reply within 1 hour during business hours."
    },
    case_studies: {
      hero_kpi_label: "Results in numbers",
      hero_kpi1_value: "40%",
      hero_kpi1_sub: "less downtime for auto workshops",
      hero_kpi2_value: "6 hrs",
      hero_kpi2_sub: "express move incl. final cleaning",
      hero_kpi3_value: "14 months",
      hero_kpi3_sub: "avg B2B contract length",
      hero_kpi4_value: "100%",
      hero_kpi4_sub: "insurance approval with video docs",
      back_home: "Back to home",
      eyebrow: "REAL PROJECTS",
      title: "Talkani in action.",
      subtitle: "Three real projects from recent months — real costs, real challenges, real outcomes. Click for the full story.",
      challenge_label: "Challenge",
      solution_label: "Our Solution",
      outcome_label: "Outcome",
      investment: "Investment",
      read_full: "Read full story",
      book_similar: "Book similar"
    },
    certifications: {
      eyebrow: "VERIFIED & CERTIFIED",
      title: "German standards, no compromises."
    },
    google_reviews: {
      eyebrow: "REVIEWS",
      title: "What our customers say on Google.",
      subtitle: "Verified reviews from real customers — collected right after each job, raw and transparent.",
      google_label: "Reviews",
      based_on: "Based on {n} reviews",
      based_on_one: "Based on {n} review",
      view_on_google: "View on Google",
      empty: "No reviews yet — we'd love your feedback after your first booking."
    },
    today_counter: {
      title: "Live · Active today",
      today_label: "Bookings today",
      km_label: "km driven",
      co2_label: "kg CO₂ saved"
    },
    exit_intent: {
      eyebrow: "Wait!",
      title: "Here's 15 € off.",
      subtitle: "Book your first Talkani service today and save 15 € — valid on all our services.",
      your_code: "Your personal code",
      copy: "Copy",
      copied: "Copied!",
      cta: "Book now with discount",
      note: "Valid for 24 hours, one-time per person",
      discount_label: "discount"
    },
    sticky_cta: {
      title: "Ready for your booking?",
      subtitle: "Book online in under 60 seconds — fixed-price guarantee",
      book_now: "Book now"
    },
    mobile_call: {
      label: "Call now"
    },
    plz_checker: {
      eyebrow: "CHECK YOUR POSTAL CODE",
      title: "Do we serve your area?",
      subtitle: "Enter your German PLZ (postal code) and we'll check instantly — including estimated distance and arrival time.",
      label: "Your postal code (PLZ)",
      placeholder: "e.g. 22047",
      check_btn: "Check",
      checking: "Checking…",
      covered_yes: "Yes! We serve {city}.",
      distance: "Approx. {km} km · arrival time ~{min} min",
      express_available: "Express available",
      express: "Express",
      book_now: "Book now",
      covered_no_title: "Not in our standard service area",
      covered_no_body: "We don't regularly serve this region. On request we can check an individual offer for you.",
      contact_us: "Send a request",
      error_format: "Please enter a valid 5-digit German postal code.",
      error_generic: "Could not check, please try again later."
    },
    referral: {
      eyebrow: "TALKANI REFERRAL PROGRAM",
      title: "Refer a friend — both get {eur} €.",
      subtitle: "Share your code with friends and family. For every first booking by your referred friend, both of you get 20 € credit toward your next bookings.",
      your_code: "Your referral code",
      copy_code: "Copy",
      copied: "Copied!",
      share_whatsapp: "WhatsApp",
      share_email: "Email",
      share_copy: "Copy message",
      email_subject: "Save 20 € with Talkani",
      stat_invites: "Invites",
      stat_redeemed: "Redeemed",
      stat_earned: "Earned",
      footnote: "You get {eur} € per successful referral — applied to your next booking credit."
    },
    chat: {
      open: "Open live chat",
      teaser_msg: "Hi 👋 Need a quick quote or have a question? We're right here.",
      contextual_teasers: {
        default: "Hi 👋 Need a quick quote or have a question? We're right here.",
        book: "Ready to book? 📅 Happy to help you find the right time slot.",
        track: "Questions about your delivery? 📦 We're here to help right away.",
        price: "Need a fixed price? 💶 Drop us a line — we reply in minutes.",
        autoteile: "Looking for a workshop delivery partner? 🔧 Express in 90 minutes possible.",
        umzug: "Planning a move? 📦 Free quote within 24 hours.",
        hausreinigung: "Weekly cleaning or a one-time deep clean? 🧹 We tailor it to you.",
        gartenpflege: "Ready for the next season? 🌿 We take care of your garden — just ask.",
        reinigung: "Need recurring office or building cleaning? ✨ We'll put a plan together.",
        dashboard: "Welcome back! 👋 Want to book another service or check a status?",
        booking_success: "Thanks for your booking! 🎉 Questions about what happens next? We're here.",
        blog: "Want to know more? 📖 Just ask — bring your specific case.",
        login: "Trouble logging in? 🔐 Drop us a line — we help right away.",
        services: "Not sure which service fits? 🛠️ Happy to advise — free of charge.",
        contact: "Rather chat than fill a form? 💬 We reply in minutes.",
        about: "Want to know more about Talkani? 👥 Ask away — we answer personally.",
        plakatservice: "Ad agency or event organiser? 📋 We swap your posters on schedule — with photo proof."
      },
      close: "Close chat",
      header_title: "Talkani Live Chat",
      header_subtitle: "Instant reply · AI assistant + team",
      form_intro: "Ask your question — our AI assistant replies instantly. Our team takes over when needed.",
      field_name: "Name",
      field_name_placeholder: "First and last name",
      field_email: "Email",
      field_email_placeholder: "name@example.com",
      field_message: "Your message",
      field_message_placeholder: "How can we help you?",
      start_btn: "Start chat",
      starting: "Starting…",
      send: "Send",
      input_placeholder: "Type a message…",
      ai_label: "Talkani Assistant",
      you_label: "You",
      admin_label: "Talkani Team",
      privacy_note: "By starting, you accept our privacy policy. We use your data only to process your request.",
      error_required: "Please fill in all fields.",
      error_generic: "Something went wrong. Please try again.",
      loading: "Loading…",
      closed_msg: "This conversation has ended.",
      start_new: "Start a new conversation",
      admin_title: "Live-Chat Messages",
      admin_refresh: "Refresh",
      admin_empty: "No conversations yet.",
      admin_select: "Select a conversation on the left.",
      admin_status_open: "Open",
      admin_status_closed: "Closed",
      admin_close: "Close",
      admin_reopen: "Reopen",
      admin_reply_placeholder: "Type your reply…",
      admin_you: "You (Team)",
      admin_closed_ok: "Conversation closed.",
      admin_reopened_ok: "Conversation reopened.",
      book_cta: "Book now",
      enable_notifications: "Enable notifications"
    }
  },
  ar: {
    nav: { home: "الرئيسية", services: "الخدمات", about: "من نحن", contact: "اتصل بنا", dashboard: "حسابي", admin: "الإدارة", login: "تسجيل الدخول", logout: "تسجيل الخروج", book: "احجز الآن", blog: "المدوّنة", b2b: "للشركات" },
    trusted_by: {
      label: "نعمل بالفعل مع",
      subtitle: "عقود دورية مع ورش السيارات وشركات التنقل المشترك في شمال ألمانيا.",
      and_more: "+ جميع دراسات الحالة"
    },
    b2b_banner: {
      eyebrow: "شريكك التجاري",
      title: "تالكاني تعمل لصالح شركتك.",
      subtitle: "ورش السيارات، وكالات الإعلان، إدارات المباني، المدارس، الفنادق والمتاجر الإلكترونية في هامبورغ تعتمد علينا لعمليات التوصيل والتنظيف والنقل اليومية — بفاتورة شهرية واحدة، ومسؤولين مخصصين، وخصم حتى 15% على الكميات.",
      cta_primary: "احجز كشركة",
      cta_secondary: "للمطورين: توثيق API",
      industries_label: "نعمل لصالح:",
      ind_werkstatt: "ورش السيارات",
      ind_agentur: "وكالات الإعلان",
      ind_hausverwaltung: "إدارات المباني",
      ind_hotel: "الفنادق والمطاعم",
      ind_schule: "المدارس والجهات الرسمية",
      ind_shop: "المتاجر الإلكترونية",
      stat1: "فاتورة واحدة شهرياً",
      stat1_sub: "بدل الفواتير المتفرقة",
      stat2: "قابل للأتمتة",
      stat2_sub: "ربط مع نظامك",
      stat3: "حتى 15% خصم",
      stat3_sub: "من 25 طلب/شهر",
      stat4: "ضمان 90 دقيقة",
      stat4_sub: "إكسبريس بالعقد",
    },
    b2b_lead: {
      eyebrow: "اطلب عرض سعر",
      title: "احصل على عرض للشركات خلال 15 دقيقة.",
      subtitle: "املأ 5 حقول — سنعود إليك خلال 24 ساعة بعرض شخصي يشمل خصم الكميات وشخص مسؤول مخصص.",
      f_company: "اسم الشركة",
      f_company_ph: "مثال: ورشة النموذج المحدودة",
      f_name: "الشخص المسؤول",
      f_name_ph: "الاسم الأول والعائلة",
      f_email: "البريد الإلكتروني",
      f_email_ph: "you@company.com",
      f_phone: "الهاتف (اختياري)",
      f_phone_ph: "+49 175 …",
      f_volume: "الحجم المتوقع",
      f_volume_help: "عدد الطلبات التقريبي شهرياً",
      vol_under_10: "أقل من 10/شهر",
      vol_10_25: "10–25/شهر",
      vol_25_100: "25–100/شهر",
      vol_100_plus: "+100/شهر",
      f_interest: "مجال الاهتمام",
      int_lieferung: "توصيل ومراسلة",
      int_autoteile: "قطع غيار للورش",
      int_reinigung: "تنظيف (عقار / مكتب / نهائي)",
      int_umzug: "خدمات النقل",
      int_escooter: "خدمة السكوترات",
      int_plakatservice: "خدمة الملصقات / الإعلانات",
      int_gartenpflege: "بستنة وخدمة شتوية",
      int_other: "أخرى",
      f_message: "وصف مختصر (اختياري)",
      f_message_ph: "ما الذي تحتاجه بشكل منتظم؟ أين؟ متى؟",
      submit: "اطلب عرض السعر",
      sending: "يتم الإرسال…",
      success_title: "شكراً — سنتواصل معك خلال 24 ساعة.",
      success_body: "وصلنا طلبك. ستستلم رسالة تأكيد قريباً.",
      error_generic: "حدث خطأ ما. يرجى المحاولة مرة أخرى أو الاتصال على +49 175 8802646.",
      required: "يرجى ملء جميع الحقول الإلزامية."
    },
    b2b: {
      meta_title: "Talkani B2B — للشركات | فاتورة موحدة · API · ضمان استجابة",
      meta_desc: "خدمات لوجستية للورش ووكالات الإعلان وإدارات العقارات والمدارس والفنادق والمتاجر الإلكترونية. فاتورة شهرية موحدة، تكامل عبر API، وضمان استجابة سريعة.",
      hero_eyebrow: "Talkani Business",
      hero_title_line1: "خدمات لوجستية تدعم",
      hero_title_line2: "أعمالك اليومية.",
      hero_subtitle: "للورش، وكالات الإعلان، إدارات العقارات، المدارس، الفنادق والمتاجر الإلكترونية ذات الاحتياجات المتكررة — مع فاتورة شهرية موحدة، تكامل API ومدير حساب مخصص.",
      hero_cta_call: "اطلب استشارة",
      hero_cta_api: "عرض الـ API",
      hero_cta_trial: "ابدأ حجزاً تجريبياً",
      segments_eyebrow: "لمن؟",
      segments_title: "قطاعك، خدمتنا.",
      seg_werkstatt_label: "ورش السيارات",
      seg_werkstatt_text: "توصيل سريع لقطع الغيار من تاجر الجملة إلى الورشة خلال 90 دقيقة. عقود يومية وأسبوعية.",
      seg_werkstatt_case1: "فرامل / فلاتر / بطاريات",
      seg_werkstatt_case2: "توصيل في اليوم نفسه",
      seg_werkstatt_case3: "خصم 20% في العقد",
      seg_werbung_label: "وكالات الإعلان واللوحات الخارجية",
      seg_werbung_text: "تغيير اللوحات (CLP، اللوحات الكبيرة، أعمدة الإعلانات) بشكل موثوق في جميع أنحاء شمال ألمانيا.",
      seg_werbung_case1: "تغيير CLP في محطات الباصات",
      seg_werbung_case2: "ملصقات أسوار البناء",
      seg_werbung_case3: "توثيق مصوّر لكل موقع",
      seg_hv_label: "إدارات العقارات",
      seg_hv_text: "تنظيف السلالم، مزاريب الأمطار، العناية بالحدائق وخدمة الشتاء لمحافظ عقارية كاملة.",
      seg_hv_case1: "تنظيف أسبوعي",
      seg_hv_case2: "عقود موسمية",
      seg_hv_case3: "خدمة طوارئ 24/7",
      seg_schule_label: "المدارس والجهات الحكومية",
      seg_schule_text: "تنظيف ولوجستيات للمؤسسات العامة — متوافق مع VOL/A وخبرة في المناقصات.",
      seg_schule_case1: "تنظيف المدارس ورياض الأطفال",
      seg_schule_case2: "الجامعات والجهات الرسمية",
      seg_schule_case3: "موظفون مدققون أمنياً",
      seg_hotel_label: "الفنادق والمطاعم",
      seg_hotel_text: "عمالة نظافة باليوم، لوجستيات الغسيل، تنظيف الواجهات والنوافذ.",
      seg_hotel_case1: "تنظيف الغرف",
      seg_hotel_case2: "قاعات الحفلات",
      seg_hotel_case3: "الواجهات الخارجية واللافتات",
      seg_shop_label: "المتاجر الإلكترونية",
      seg_shop_text: "توصيل في اليوم نفسه لهامبورغ والمناطق المحيطة. شحنات عاجلة، سلع ضخمة، مرتجعات.",
      seg_shop_case1: "توصيل خلال 4 ساعات",
      seg_shop_case2: "سلع ضخمة حتى 2 م³",
      seg_shop_case3: "إثبات مصوّر عند التسليم",
      features_eyebrow: "ما الذي تحصل عليه",
      features_title: "6 أسباب لاختيار Talkani Business.",
      f_invoice_title: "فاتورة موحدة",
      f_invoice_text: "فاتورة واحدة شهرياً — متوافقة مع DATEV، تُرسَل تلقائياً.",
      f_api_title: "API و Webhooks",
      f_api_text: "ادمج Talkani مباشرة في نظام ERP الخاص بك (REST + Webhooks).",
      f_sla_title: "ضمان استجابة سريعة",
      f_sla_text: "ضمان استجابة خلال 90 دقيقة — موثق تعاقدياً.",
      f_account_title: "مدير حساب",
      f_account_text: "شخص اتصال مخصص لجميع شؤونك.",
      f_gdpr_title: "GDPR و AVV",
      f_gdpr_text: "عقد معالجة بيانات عند الطلب. ممتثل تماماً لـ GDPR.",
      f_scale_title: "قابل للتوسع",
      f_scale_text: "من 5 إلى 5000 طلب شهرياً. خصومات حجم عادلة.",
      api_badge: "واجهة المطورين",
      api_title: "ادمج Talkani في يوم واحد.",
      api_intro_pre: "إذا كان نظام ERP أو نظام الورشة أو برنامج التوزيع لديك يدعم REST بالفعل، يمكنك ربط Talkani خلال ",
      api_intro_strong: "أقل من 8 ساعات",
      api_intro_post: ". لا توجد رسوم ترخيص — تدفع فقط مقابل الطلبات المنفذة.",
      api_b1_b: "OpenAPI 3.1",
      api_b1: " — توثيق Swagger تفاعلي، مختبر مع كل عميل HTTP",
      api_b2_b: "JSON دخل ← JSON خرج",
      api_b2: " — لا SOAP معقد، لا XML",
      api_b3_b: "Webhooks",
      api_b3: " — تحديثات الحالة تُدفَع إلى endpoint الخاص بك، لا حاجة للاستعلام المستمر",
      api_b4_b: "Sandbox + Production",
      api_b4: " — اختبر في بيئة منفصلة، أطلق عند الجاهزية",
      api_b5_b: "أمثلة كود",
      api_b5: " — cURL، Python، Node.js، PHP — قابلة للنسخ مباشرة من التوثيق",
      api_open_docs: "افتح توثيق الـ API",
      api_request_key: "اطلب مفتاح شريك",
      api_code_response: "# الاستجابة",
      steps_eyebrow: "في 4 خطوات",
      steps_title: "هكذا تنطلق.",
      step1_title: "1. اقرأ التوثيق",
      step1_text: "افتح /api/docs — مواصفات OpenAPI تفاعلية كاملة لكل نقاط النهاية.",
      step2_title: "2. اطلب مفتاح شريك",
      step2_text: "راسلنا على info@talkani.de — نرسل لك API token + مسودة AVV.",
      step3_title: "3. ادمج",
      step3_text: "نداءات REST مباشرة من نظام ERP/التوزيع لديك. JSON دخل، JSON خرج.",
      step4_title: "4. استقبل Webhooks",
      step4_text: "تغيّرات الحالة (تم الاستلام ← تم التأكيد ← في الطريق ← اكتمل) تصل تلقائياً إلى نظامك.",
      pricing_eyebrow: "خصومات حسب الكمية",
      pricing_title: "تتوسّع بشكل عادل مع حجمك.",
      tier_starter: "Starter",
      tier_starter_jobs: "حتى 25 / شهرياً",
      tier_starter_rabatt: "0%",
      tier_growth: "Growth",
      tier_growth_jobs: "25 – 100 / شهرياً",
      tier_growth_rabatt: "8%",
      tier_enterprise: "Enterprise",
      tier_enterprise_jobs: "100+ / شهرياً",
      tier_enterprise_rabatt: "حسب الاتفاق",
      tier_discount_label: "خصم الكمية",
      tier_f1: "فاتورة موحدة",
      tier_f2: "مدير حساب",
      tier_f3: "Express-SLA",
      tier_f4: "وصول للـ API",
      final_cta_title: "حدّد موعداً للحديث.",
      final_cta_text: "في 15 دقيقة نناقش احتياجاتك ونقدّم عرضاً مخصصاً.",
    },
    hero: {
      eyebrow: "تالكاني · لوجستيك · تنظيف · خدمات للشركات",
      title: "سريع. موثوق. مرن.",
      subtitle: "شريكك اللوجستي والتنظيفي في هامبورغ — توصيل الطرود، إمداد قطع الغيار، خدمة 2 Mann Handling مع تركيب الأثاث، تنظيف لإدارات المباني والفنادق، خدمات النقل، والخدمة الليلية للسكوترات لشركات التنقل المشترك. نعمل لصالح الورش والمتاجر الإلكترونية والشركات والأسر في هامبورغ وشمال ألمانيا.",
      cta_primary: "احجز خدمة",
      cta_secondary: "عرض الخدمات"
    },
    about_intro: {
      eyebrow: "من نحن",
      title: "أكثر من مجرد لوجستيات.",
      body: "تالكاني شركة خدمات حديثة للوجستيات والتنظيف والخدمات. نتولى النقل الموثوق والتسليم في الوقت المحدد للطرود والأطعمة والأدوية والمخبوزات والزهور وغيرها من الشحنات الحساسة والعاجلة. كشركة خدمات مرنة، نحن منفتحون على الطلبات الفردية — تواصل معنا وسنطور لك حلاً مخصصاً.",
      stat1_value: "+10", stat1_label: "خدمات",
      stat2_value: "24/7", stat2_label: "متاحون دائماً",
      stat3_value: "100%", stat3_label: "موثوقية"
    },
    services: {
      eyebrow: "خدماتنا",
      title: "كل شيء من مصدر واحد.",
      lieferung: { name: "التوصيل والتسليم", desc: "توصيل آمن ودقيق لكل أنواع الشحنات — نوصّل: • طروداً وعبوات (Same-Day في هامبورغ) • أطعمة ومشتريات (مع تبريد عند الطلب) • أدوية ومستلزمات الصيدلية • مخبوزات وفواكه طازجة (صباحاً مبكراً) • زهور وشحنات حسّاسة • وثائق وسعاة سريعون • مشروبات ومشتريات بالجملة. تتبّع GPS وتوثيق صور عند التسليم وسائقون شخصيون — شحنتك تحصل على اسم، وليس فقط رقم تتبّع." },
      escooter_service: { name: "خدمة E-Scooter", desc: "خدمات لوجستية كاملة لمشغّلي أساطيل السكوتر الكهربائي — نتولّى: • شحن وتبديل البطاريات ليلياً • نقل المركبات المعطّلة إلى الورشة • توزيع السكوترات الجاهزة في المناطق الحيوية • النقل بين المستودع والمدينة • تنظيف وصيانة المركبات • تقارير المخزون والمواقع. قابل للتوسّع من 50 إلى 5,000 مركبة — مناسب لخدمات Sharing في هامبورغ وجميع أنحاء شمال ألمانيا." },
      umzug: { name: "النقل، الإخلاء، التنظيف وأعمال الدهان", desc: "نقل كامل من مزوّد واحد — نتولّى: • نقل الأثاث مع تغليف واقٍ • التغليف بكراتين ومواد متخصّصة • تركيب وفك الأثاث (بما فيه IKEA) • إخلاء الشقة والقبو والعليّة • تنظيف نهائي شامل (besenrein أو لامع تماماً) • أعمال الدهان (صبغ الجدران، إصلاحات، تجديد) • نقل البيانو والأثاث الخاص. ضمان سعر ثابت، بدون تكاليف خفيّة، وممثّل واحد لكل شيء." },
      reinigung: { name: "خدمات التنظيف (جميع الأنواع)", desc: "تنظيف احترافي لجميع المباني والمساحات — نُغطّي: • تنظيف السلالم (Hausverwaltungen / العمارات السكنية) • تنظيف النوافذ والزجاج (داخل وخارج، حتى الطوابق العالية) • تنظيف المكاتب والعيادات • الدوائر الحكومية، الجامعات، المدارس، الروضات ومراكز التدريب • الفنادق، المحلات التجارية، العيادات والمتاجر • تنظيف غرف القمامة والباحات • إزالة الكتابات والرسومات (Graffiti) من الواجهات وأبواب الكراج وواجهات المحلات — بأساليب لطيفة لا تُتلف السطح • التنظيف العميق وتنظيف ما بعد البناء. بمعدات احترافية وكوادر مدرّبة — وعند الطلب بعد ساعات العمل أو كعقد صيانة منتظم." },
      hausreinigung: { name: "تنظيف البيوت والمنازل الخاصة", desc: "تنظيف منتظم أو لمرة واحدة لمنزلك — ننظّف: • غرف المعيشة والنوم • المطبخ (أسطح العمل، الأجهزة، واجهات الخزائن) • الحمامات (صحّيات، بلاط، مرايا) • النوافذ والأبواب والأرضيات • مسح الغبار وإزالة خيوط العنكبوت • تفريغ القمامة وتبديل أغطية السرير (عند الطلب). موادنا الخاصة الصديقة للبيئة، موظّفون بهدوء ودقّة — أسبوعياً أو كل أسبوعين أو شهرياً. مثالي للعائلات وأصحاب الأعمال وكبار السن." },
      gartenpflege: { name: "العناية بالحديقة وتنظيفها", desc: "عناية كاملة بحديقتك — موسماً بموسم: • قص العشب وتهوية وتسميد التربة • تقليم الأسوار الخضراء والشجيرات (بجميع الارتفاعات) • إزالة الأعشاب الضارّة (ميكانيكياً وحرارياً) • تنظيف الممرّات والتراسات والبلاط • إزالة وتدوير أوراق الخريف • تنظيف الربيع والخريف الكامل • العناية بالأشجار وإصلاح أضرار العواصف • العناية بالقبور وزراعتها. منتظم (أسبوعياً، كل أسبوعين، شهرياً) للحدائق الخاصة والمباني السكنية والمساحات التجارية." },
      autoteile: { name: "توصيل قطع غيار السيارات للورش", desc: "لوجستيات ورشية سريعة في هامبورغ ومحيطها — نوصّل: • فرامل، فلاتر وقطع التآكل • بطاريات، دينامو ومحرّكات التشغيل • مرايا، زجاج وقطع الهيكل • زيوت، شحوم ومواد التشغيل • أدوات ومستهلكات الورشة • إطارات وجنوط (مع استلام موسمي). عدّة جولات يومياً، Same-Day أو Express خلال 90 دقيقة. عقود إطار B2B مع فاتورة شهرية موحّدة." },
      regenrinne_reinigung: { name: "تنظيف المزاريب والأنابيب بالكاميرا", desc: "تنظيف احترافي بشفافية كاملة — تشمل خدمتنا: • تنظيف مزاريب الأسطح والأنابيب الساقطة • فحص داخلي بكاميرا متخصّصة (Endoskop) • شطف الأنابيب بالضغط العالي • توثيق فيديو كامل • صور قبل/بعد لكل جزء • توصيات بفترات الصيانة. مناسبة للعمارات السكنية والمنشآت التجارية وشركات إدارة العقارات — مع تقرير مفصّل لملفّاتك." },
      winterdienst: { name: "خدمة الشتاء وإزالة الثلوج", desc: "تنفيذ احترافي لواجب الإزالة والرشّ — نتولّى: • إزالة الثلوج من الأرصفة والممرّات والباحات • الرشّ بالملح أو حبيبات صديقة للبيئة • إخلاء الشوارع ومواقف السيارات والمساحات التجارية • استعداد 24/7 عند تساقط الثلج • عقود موسمية بسعر ثابت (نوفمبر–مارس) • مكافحة الجليد وكسر طبقات الثلج. أقصى درجات الأمان للسكان والموظفين والزبائن — نتحمّل المسؤولية القانونية للإزالة." },
      zweimann_handling: { name: "2 Mann Handling وتركيب الأثاث", desc: "توصيل موثوق بشخصين للشحنات الثقيلة والأثاث الكبير — نتولّى: • الأرائك والأسِرَّة والخزائن الجدارية (مع حصائر انزلاق وحماية الحواف) • الغسّالات والثلاجات وأجهزة الجلي • خزائن المطابخ والمطبخ الكامل (مع التوصيل عند الطلب) • شاشات التلفاز الكبيرة 65\" فأكثر • أجهزة الرياضة وكراسي المساج • حتى الطابق الرابع بدون مصعد، ومع المصعد جميع الطوابق • تركيب الأثاث حسب التعليمات • أخذ التغليف والتخلص من الأجهزة القديمة (مسجّل EAR). مثالي للمتاجر الإلكترونية وإدارات المباني والعملاء الأفراد. من €59 قياسي · €89 Handling+ · €149 خدمة كاملة." },
      plakatservice: { name: "خدمة الإعلانات الخارجية وتبديل الملصقات", desc: "لوجستيات إعلانات خارجية احترافية للوكالات والمنظّمين — نقدّم: • City-Light-Poster (CLP) في محطات الباص • لوحات كبيرة (18/1) وMega-Light • أعمدة إعلانية وجدران ملصقات • لصق الملصقات على أسوار البناء • حملات Stickers وDecals • تبديل عاجل وتركيب Express • توثيق بالصور (قبل/بعد + GPS لكل موقع) • تخلّص صحيح من الملصقات القديمة. متوافقون مع JCDecaux و Ströer و Wall و Awk وأنظمة أخرى — في الموعد، موثّق، وموثوق." }
    },
    specialty: {
      eyebrow: "توصيلات متخصصة",
      title: "نوصّل كل شيء. بأمان، طازج، في الوقت المحدد.",
      subtitle: "مهما كنت تريد إرساله — لدينا الحل المناسب. بعض من تخصصاتنا:",
      blumen: { name: "الزهور", desc: "باقات زهور ونباتات طازجة — مغلّفة بعناية، يتم توصيلها بسرعة. مثالية لأعياد الميلاد والذكرى السنوية والمناسبات." },
      backwaren: { name: "المخبوزات", desc: "خبز طازج وكرواسون وكعك ومعجنات — من المخبزة مباشرة إليك أو إلى عملائك، لا تزال دافئة وطازجة." },
      zeitungen: { name: "الصحف والجرائد", desc: "توصيل موثوق في الصباح الباكر للصحف اليومية والأسبوعية — في الوقت المحدد قبل القهوة الأولى، في أي طقس." },
      medikamente: { name: "الأدوية", desc: "توصيل آمن وسري لمنتجات الصيدلية والأدوية — مع التحكم بدرجة الحرارة والسرية التامة." },
      andere: { name: "خدمة أخرى", desc: "تحتاج شيئاً غير موجود في قائمتنا؟ لا مشكلة — صف لنا طلبك ببساطة، وسنطوّر حلاً مفصلاً خصيصاً لك." }
    },
    testimonials: {
      eyebrow: "آراء العملاء",
      title: "ماذا يقول عملاؤنا.",
      subtitle: "تقييمات حقيقية من عملائنا — صادقة ومباشرة.",
      empty_title: "لا توجد تقييمات بعد.",
      empty_body: "كن أول من يقيّمنا! نرحب بملاحظاتك بعد كل خدمة.",
      write_btn: "اكتب تقييماً",
      form_title: "تقييمك",
      form_name: "اسمك (يظهر علناً)",
      form_role: "الوظيفة / الشركة (اختياري)",
      form_rating: "النجوم",
      form_text: "ما رأيك في خدمتنا؟",
      form_submit: "إرسال التقييم",
      form_cancel: "إلغاء",
      form_login_required: "الرجاء تسجيل الدخول أولاً لإرسال تقييم.",
      form_success: "شكراً لك على تقييمك!"
    },
    values: {
      eyebrow: "لماذا تالكاني",
      title: "قيم يمكنك الاعتماد عليها.",
      reliability: { title: "الموثوقية", desc: "في الوقت المحدد، بعناية واحترافية — في كل مهمة." },
      quality: { title: "الجودة", desc: "فريق مدرب وعمليات فعّالة لأعلى جودة." },
      flexibility: { title: "المرونة", desc: "حلول مخصصة للمتطلبات الفردية." },
      satisfaction: { title: "رضا العملاء", desc: "رضاكم يأتي دائماً في المقام الأول بالنسبة لنا." }
    },
    cta_banner: { title: "هل أنت مستعد لبدء مهمتك؟", subtitle: "احجز عبر الإنترنت في أقل من 60 ثانية.", button: "احجز الآن" },
    contact: {
      eyebrow: "اتصل بنا",
      title: "تحدث إلينا.",
      name: "الاسم", email: "البريد الإلكتروني", phone: "الهاتف", subject: "الموضوع", message: "رسالتك", send: "إرسال الرسالة",
      sent: "تم إرسال الرسالة — سنتواصل معك قريباً.",
      address_label: "العنوان", phone_label: "الهاتف", email_label: "البريد"
    },
    footer: { rights: "جميع الحقوق محفوظة.", imprint: "بيانات الناشر", privacy: "الخصوصية", agb: "الشروط والأحكام", cookies: "إعدادات الملفات" },
    voice: { title: "حجز بالصوت · جديد", subtitle: "تحدّث بطلبك — سنملأ النموذج تلقائياً.", start: "ابدأ التسجيل", stop: "تم", recording: "جاري التسجيل…", processing: "جاري النسخ…", transcript: "النص", again: "حاول مرة أخرى" },
    text_booking: { title: "حجز بالكتابة", subtitle: "صِف طلبك بالكلمات — الذكاء الاصطناعي يملأ النموذج تلقائياً.", start: "اكتب الطلب", submit: "تعبئة تلقائية", cancel: "إلغاء", processing: "جاري المعالجة…", placeholder: "مثلاً: 'أحتاج غداً 2 ظهراً نقل من Eimsbüttel إلى Altona، شقتين'", error: "لم تُحدّد الحقول — يرجى التوضيح أكثر." },
    auth: {
      sign_in: "تسجيل الدخول بـ Google", sign_in_title: "مرحباً بعودتك", sign_in_subtitle: "سجل الدخول لإدارة حجوزاتك.",
      create_account: "إنشاء حساب", create_account_subtitle: "أنشئ حسابك الشخصي في Talkani.",
      tab_signin: "تسجيل الدخول", tab_register: "إنشاء حساب",
      password: "كلمة المرور", or: "أو",
      sign_in_btn: "تسجيل الدخول", create_account_btn: "إنشاء الحساب",
      processing: "جاري تسجيل الدخول...",
      forgot_password: "نسيت كلمة المرور؟",
      forgot_title: "إعادة تعيين كلمة المرور",
      forgot_subtitle: "أدخل بريدك الإلكتروني. سنرسل لك رابط إعادة التعيين.",
      forgot_submit: "إرسال الرابط",
      forgot_sent_title: "تم إرسال الرابط",
      forgot_sent_body: "إذا كان حساب بهذا البريد موجوداً، فقد أرسلنا لك رابطاً لإعادة التعيين. تحقّق أيضاً من مجلد الرسائل غير المرغوبة. الرابط صالح لمدة 30 دقيقة.",
      back_to_login: "العودة لتسجيل الدخول",
      reset_title: "تعيين كلمة مرور جديدة",
      reset_subtitle: "اختر كلمة مرور قوية لحسابك في تالكاني.",
      reset_new_password: "كلمة المرور الجديدة",
      reset_confirm_password: "تأكيد كلمة المرور",
      reset_password_hint: "8 أحرف على الأقل. يُفضّل أن تشمل أحرفاً وأرقاماً ورموزاً خاصة.",
      reset_password_too_short: "يجب أن تكون كلمة المرور 8 أحرف على الأقل.",
      reset_password_mismatch: "كلمتا المرور غير متطابقتين.",
      reset_submit: "حفظ كلمة المرور",
      reset_success_title: "تم تحديث كلمة المرور",
      reset_success_body: "تم تغيير كلمة مرورك بنجاح. ستتم إعادة توجيهك لتسجيل الدخول.",
      reset_invalid_title: "رابط غير صالح",
      reset_invalid_body: "هذا الرابط غير صالح أو منتهي الصلاحية. الرجاء طلب رابط جديد.",
      reset_invalid_link: "الرابط غير صالح. الرجاء طلب رابط جديد."
    },
    booking: {
      title: "احجز خدمة", step: "خطوة", of: "من",
      step1: "اختر الخدمة", step2: "التاريخ والوقت", step3: "التفاصيل", step4: "تأكيد",
      step1_main: "الخدمات الرئيسية", step1_specialty: "توصيلات متخصصة",
      date: "التاريخ", time: "الوقت", name: "الاسم", email: "البريد الإلكتروني", address: "العنوان", phone: "الهاتف", details: "تفاصيل إضافية (اختياري)",
      details_custom: "صف لنا طلبك",
      details_custom_placeholder: "ما الذي تريد توصيله / إنجازه؟ صف لنا طلبك باختصار.",
      back: "السابق", next: "التالي", confirm: "تأكيد الحجز", success: "تم تأكيد الحجز!", success_msg: "سنرسل لك تأكيداً عبر البريد الإلكتروني.",
      view_bookings: "عرض حجوزاتي",
      have_code: "إضافة كود إحالة أو خصم",
      referral_code_label: "كود الإحالة",
      discount_code_label: "كود الخصم",
      referral_valid: "كود من {name} صالح — توفّر {eur} €",
      referral_invalid: "الكود غير صالح أو منتهٍ.",
      code_note: "كلا الكودين اختياريان. سنحسب السعر النهائي ونطبّق الخصم قبل التأكيد."
    },
    dashboard: {
      title: "حجوزاتي", new_booking: "حجز جديد", empty: "ليس لديك أي حجوزات بعد.", book_now: "احجز الآن",
      status: { pending: "قيد الانتظار", confirmed: "مؤكد", in_progress: "قيد التنفيذ", completed: "مكتمل", cancelled: "ملغي" }
    },
        admin_analytics: { eyebrow: "التحليلات", title: "تحليل الحجوزات", subtitle: "نظرة أسبوعية: المؤكدة مقابل الملغاة لكل خدمة.", weekly_title: "الاتجاه الأسبوعي", by_service_title: "الحجوزات حسب الخدمة" },
    cookie_consent: {
      aria_label: "إعدادات ملفات تعريف الارتباط",
      banner_title: "نحترم خصوصيتك.",
      banner_body: "نستخدم ملفات تعريف ارتباط ضرورية لتشغيل الموقع. بموافقتك، نودّ أيضاً استخدام إحصائيات استخدام مجهولة الهوية وملفات تعريف تسويقية. يمكنك سحب موافقتك في أي وقت.",
      privacy_link: "سياسة الخصوصية",
      imprint_link: "بيانات الناشر",
      accept_all: "قبول الكل",
      only_necessary: "الضرورية فقط",
      settings: "الإعدادات",
      settings_title: "إعدادات الملفات",
      settings_body: "اختر الملفات المسموح بتعيينها. الملفات الضرورية لا يمكن إيقافها — بدونها لا يعمل الحجز ولا تسجيل الدخول ولا اختيار اللغة.",
      cat_necessary_title: "ضرورية",
      cat_necessary_body: "مطلوبة لتشغيل الموقع الأساسي (إدارة الجلسات، نموذج الحجز، اختيار اللغة). بدونها لا يعمل الموقع بشكل صحيح.",
      cat_analytics_title: "تحليلات",
      cat_analytics_body: "إحصائيات استخدام مجهولة الهوية (الصفحات المزارة، التنبيهات التي يضغطها العملاء). لا نُنشئ ملفات شخصية.",
      cat_marketing_title: "تسويق",
      cat_marketing_body: "يُفعّل رموز الإحالة، وتتبّع الحملات، وإحصائيات فتح رسائل التأكيد.",
      item_session: "الجلسة وتسجيل الدخول (auth_session)",
      item_lang: "اختيار اللغة (de / en / ar)",
      item_booking_id: "معرّف الحجز النشط لأغراض التتبع",
      item_teasers: "ظهور تنبيهات الشات (أي تنبيه سياقي تم عرضه)",
      item_chat_meta: "بيانات محادثة مجهولة (اللغة، المنطقة الزمنية)",
      item_referral: "تتبّع رمز الإحالة (?ref=…)",
      item_email_track: "تتبّع فتح البريد الإلكتروني (رسائل الحجز والحالة)",
      save_selection: "حفظ الاختيار",
      footer_note: "اختيارك صالح لمدة 12 شهراً. يمكنك تغييره أي وقت من",
    },
    admin_leads: {
      eyebrow: "قناة الشركات",
      title: "طلبات الشركات",
      subtitle: "إدارة جميع طلبات الشركات الواردة وتتبعها عبر مراحل القناة.",
      total: "المجموع",
      all: "الكل",
      status_new: "جديد",
      status_contacted: "تم التواصل",
      status_qualified: "مؤهل",
      status_won: "فوز",
      status_lost: "خسارة",
      mark_contacted: "تم التواصل",
      mark_qualified: "تأهيل",
      mark_won: "فوز",
      mark_lost: "خسارة",
      details: "تفاصيل",
      hide: "إخفاء",
      message_label: "رسالة العميل",
      empty: "لا توجد طلبات في هذا الفلتر بعد.",
      status_updated: "تم تحديث الحالة."
    },
    admin: { title: "الإدارة – كل الحجوزات", customer: "العميل", service: "الخدمة", datetime: "التاريخ/الوقت", status: "الحالة", actions: "إجراءات", update: "تحديث", confirm: "تأكيد", complete: "إنجاز", cancel: "إلغاء", reopen: "إعادة فتح", delete: "حذف", delete_test: "حذف حجوزات الاختبار", delete_test_confirm: "هل تريد فعلاً حذف جميع حجوزات الاختبار (Refactor QA, test_*, example.com)?", delete_confirm: "هل تريد فعلاً حذف هذا الحجز؟", email_sent: "تم إشعار العميل عبر البريد الإلكتروني" },
    calculator: {
      eyebrow: "حاسبة الأسعار",
      title: "السعر فوراً، بدون مكالمة.",
      subtitle: "احصل على تقدير سعري غير ملزم في ثوانٍ. يتم تأكيد السعر النهائي بعد مراجعة قصيرة.",
      disclaimer: "جميع الأسعار تقديرات أولية غير ملزمة. يُحسب السعر النهائي بشكل عادل وشفاف بعد مراجعة طلبك.",
      tag: "حاسبة تالكاني",
      headline: "احسب سعرك فوراً",
      field_service: "الخدمة",
      field_size: "النطاق",
      field_distance: "المسافة",
      size_small: "صغير",
      size_medium: "متوسط",
      size_large: "كبير",
      size_small_umzug: "غرفة واحدة",
      size_medium_umzug: "2–3 غرف",
      size_large_umzug: "4+ غرف",
      size_small_reinigung: "حتى ساعتين",
      size_medium_reinigung: "3–4 ساعات",
      size_large_reinigung: "5–8 ساعات",
      size_small_hausreinigung: "شقة حتى 60 م²",
      size_medium_hausreinigung: "بيت 60–120 م²",
      size_large_hausreinigung: "بيت 120+ م²",
      size_small_gartenpflege: "صغيرة حتى 100 م²",
      size_medium_gartenpflege: "متوسطة 100–300 م²",
      size_large_gartenpflege: "كبيرة 300+ م²",
      size_small_autoteile: "حتى 5 قطع / جولة",
      size_medium_autoteile: "عقد يومي 5–20 قطعة",
      size_large_autoteile: "تعرفة يومية 20+ / جولات متعددة",
      size_small_regenrinne_reinigung: "منزل مفرد",
      size_medium_regenrinne_reinigung: "منزل مزدوج",
      size_large_regenrinne_reinigung: "مبنى سكني",
      size_small_winterdienst: "زيارة واحدة",
      size_medium_winterdienst: "عدة زيارات",
      size_large_winterdienst: "عقد موسمي",
      result_label: "السعر التقديري",
      from: "من",
      cta_book: "احجز الآن",
      cta_contact: "اطلب عرضاً",
      lieferung_note: "يشمل الرسوم الأساسية ورسوم الكيلومتر. التوصيل السريع متاح عند الطلب.",
      umzug_note: "يشمل حمّالين اثنين والنقل. التغليف والإخلاء متاحان اختيارياً.",
      reinigung_note: "ساعتان كحد أدنى، يشمل المواد والمواصلات داخل منطقة هامبورغ.",
      hausreinigung_note: "يشمل موادنا الخاصة والمواصلات. خصم عند الحجز الأسبوعي أو كل أسبوعين.",
      gartenpflege_note: "يشمل المعدات والتخلص من المخلفات النباتية حتى 1 م³. عقد موسمي بأفضل سعر طوال السنة.",
      autoteile_note: "خدمة Express خلال 90 دقيقة شاملة إرجاع القطع القديمة. عقود يومية وأسبوعية بأسعار خاصة.",
      regenrinne_note: "يشمل الفحص بكاميرا الأنابيب وتوثيق فيديو كامل.",
      winterdienst_note: "لكل زيارة يشمل مواد الرش. العقد الموسمي يقدم أفضل سعر.",
      escooter_note: "لمشغلي الأساطيل: عرض مخصص حسب المدينة وحجم الأسطول ونطاق الخدمة.",
      plakatservice_note: "لوكالات الإعلانات ومنظّمي الفعاليات: حزم مخصّصة حسب المقاس (CLP، لوحة كبيرة، عمود إعلاني)، عدد المواقع وتكرار التبديل.",
      you_save: "توفر",
      combo_title: "+ تنظيف الشقة القديمة بعد الانتقال",
      combo_badge: "-20%",
      combo_desc: "نُنظف شقتك القديمة بعد الانتقال — جاهزة للتسليم. وفّر 30 € عند الجمع بين الخدمتين."
    },
    before_after: {
      eyebrow: "قبل · بعد",
      title: "شاهد الفرق بنفسك.",
      subtitle: "اسحب الفاصل لرؤية النتيجة الحقيقية. أمثلة فعلية من أعمالنا.",
      disclaimer: "صور توضيحية تمثل نتائج نموذجية. مراجع حقيقية من مهام محددة متاحة عند الطلب.",
      regenrinne_title: "المزراب · مسدود → نظيف",
      regenrinne_desc: "تنظيف كامل مع فحص بالكاميرا وتوثيق فيديو.",
      reinigung_title: "تنظيف المباني · قبل وبعد",
      reinigung_desc: "تنظيف احترافي للمكاتب والسلالم والمساحات التجارية.",
      entruempelung_title: "إخلاء · ممتلئ → فارغ",
      entruempelung_desc: "أقبية، عليّات، وشقق — يتم إخلاؤها وتسليمها نظيفة تماماً."
    },
    trust: {
      eyebrow: "الثقة والجودة",
      title: "ما يمكنك الاعتماد عليه.",
      subtitle: "نعمل بجدية وشفافية وبمعايير ألمانية حقيقية — من التأمين إلى ضمان السعر الثابت.",
      insured_title: "شركة عائلية",
      insured_desc: "إدارة شخصية من هامبورغ. التغطية التأمينية قيد الاستكمال — يتم توضيح الحالة الحالية بشفافية قبل كل مهمة.",
      gdpr_title: "متوافق 100% مع GDPR",
      gdpr_desc: "بياناتك تبقى في ألمانيا. نقل مشفر، ولا تُشارك مع أي طرف ثالث.",
      hamburg_title: "شركة عائلية في هامبورغ",
      hamburg_desc: "تالكاني — مقرّها هامبورغ، شركة عائلية قيد التأسيس (in Gründung).",
      tax_title: "فاتورة نظيفة",
      tax_desc: "فاتورة شفافة مع ضريبة القيمة المضافة الواضحة — قابلة للخصم الضريبي للأفراد والشركات.",
      fixed_price_title: "ضمان السعر الثابت",
      fixed_price_desc: "ما نتفق عليه مسبقاً هو ما تدفعه — لا تكاليف خفية أبداً.",
      premium_equipment_title: "معدات احترافية معتمدة",
      premium_equipment_desc: "نستخدم معدات احترافية معتمدة (Kärcher، كاميرات أنابيب، معدات إزالة ثلوج) وكوادر مدربة."
    },
    team: {
      eyebrow: "فريقنا",
      title: "أشخاص يوصلون النتائج.",
      subtitle: "خلف تالكاني فريق منسجم من المتخصصين في اللوجستيات والتنظيف والخدمات — هدفنا واحد: رضاكم.",
      owner_tag: "الإدارة العليا",
      owner_role: "المدير العام",
      owner_bio: "يقود تالكاني منذ التأسيس بتركيز واضح على جودة الخدمة ورضا العملاء.",
      operations_tag: "العمليات",
      operations_role: "مديرة العمليات",
      operations_bio: "تنسّق الطلبات والمسارات والتواصل مع العملاء — أول من تتواصل معه.",
      logistics_tag: "اللوجستيات",
      logistics_role: "قائد فريق اللوجستيات",
      logistics_bio: "يقود طاقم السائقين ويضمن التسليم الموثوق وفي الوقت المحدد على مستوى ألمانيا.",
      cleaning_tag: "التنظيف",
      cleaning_role: "قائدة فريق التنظيف",
      cleaning_bio: "تدير فريق التنظيف بأعلى المعايير للمكاتب والمباني والمنازل."
    },
    service_area: {
      eyebrow: "منطقة الخدمة",
      title: "هامبورغ وكل ألمانيا.",
      subtitle: "مقرنا الرئيسي في هامبورغ — نخدم منطقة العاصمة بأكملها وننفذ مهام على مستوى ألمانيا عند الطلب.",
      hq_tag: "المقر الرئيسي",
      feature_1: "خدمة 24/7 في منطقة هامبورغ الكبرى",
      feature_2: "توصيل سريع في نفس اليوم في شمال ألمانيا",
      feature_3: "انتقالات ولوجستيات على مستوى ألمانيا عند الطلب",
      cities_label: "نغطي أيضاً",
      city_hamburg: "هامبورغ",
      city_bremen: "بريمن",
      city_hannover: "هانوفر",
      city_berlin: "برلين",
      city_luebeck: "لوبيك",
      city_kiel: "كيل",
      city_rostock: "روستوك",
      city_leipzig: "لايبزيغ",
      city_duesseldorf: "دوسلدورف",
      city_frankfurt: "فرانكفورت",
      city_muenchen: "ميونخ",
      city_stuttgart: "شتوتغارت"
    },
    live_activity: {
      label: "نشاط مباشر",
      template: "{activity} · {city} · قبل {mins} دقيقة",
      activities: [
        "حُجز للتو: انتقال",
        "حُجز للتو: تنظيف مزاريب",
        "طلب جديد: تنظيف مكاتب",
        "اكتمل: توصيل سريع",
        "طلب جديد: إخلاء",
        "موعد مؤكد: خدمة شتاء",
        "حُجز للتو: خدمة E-Scooter"
      ]
    },
    blog: {
      eyebrow: "تالكاني · رؤى",
      page_title: "أدلّة في اللوجستيات والانتقال والتنظيف.",
      page_subtitle: "نصائح حقيقية من أكثر من ألف مهمة — شُرحت بوضوح، بدون كلام تسويقي.",
      min_read: "دقيقة قراءة",
      read_more: "تابع القراءة",
      back_to_blog: "العودة إلى المدوّنة",
      related: "مقالات أخرى",
      empty: "لا توجد مقالات منشورة بعد.",
      not_found: "المقال غير موجود.",
      cta_eyebrow: "جاهز لمهمتك؟",
      cta_title: "لنتحدث عن مشروعك.",
      cta_subtitle: "احصل على عرض غير ملزم من تالكاني في 60 ثانية."
    },
    pwa: {
      label: "تطبيق تالكاني",
      title: "ثبّت تطبيق تالكاني على جهازك.",
      body: "وصول أسرع، حجز بضغطة واحدة، وإشعارات للتحديثات المهمة — مباشرة من الشاشة الرئيسية.",
      install_btn: "ثبّت الآن",
      ios_hint: "iOS: اضغط على أيقونة المشاركة في الأسفل واختر «إضافة إلى الشاشة الرئيسية»."
    },
    autoteile_story: {
      eyebrow: "توصيل قطع الغيار — كيف نعمل",
      title: "من المستودع إلى الورشة — خلال 90 دقيقة.",
      subtitle: "نظرة شفّافة على خدمة الـ Express لقطع غيار السيارات في هامبورغ: موثوقة، موثَّقة، ودقيقة في الموعد دائماً.",
      steps: [
        {
          n: "01",
          label: "تجهيز آمن",
          title: "من المستودع — تعبئة دقيقة بدون أخطاء.",
          body: "نستلم القطع مباشرة من تاجر الجملة، نتحقّق من رقم الطلب والكمية، ونعبّئ كل شيء في صناديق شحن متينة ومحايدة. كل شحنة تُمسح ضوئياً عند التحميل — ترى الحالة المباشرة في تطبيقنا."
        },
        {
          n: "02",
          label: "في الطريق عبر هامبورغ",
          title: "توصيل Express متتبَّع بـ GPS.",
          body: "بسيارة Sprinter خاصة بنا نطوف هامبورغ عدة مرات يومياً. تحسين المسار يضمن وصول طلبيتك بأقصر طريق — حتى في ساعات الذروة. خدمة Express في أقل من 90 دقيقة متاحة."
        },
        {
          n: "03",
          label: "التسليم في الورشة",
          title: "وصل — مباشرة إلى الرافعة.",
          body: "نصل حتى الكاونتر أو مباشرة إلى الرافعة، نسلّم الطرد المختوم شخصياً ونأخذ القطع القديمة للتخلّص منها. إيصال الاستلام موقّع — والعمل يستمر."
        }
      ],
      cta: "اطلب أسعار الورش"
    },
    subscription: {
      eyebrow: "تالكاني بلَس — الاشتراكات",
      title: "أجواء نظيفة، كل أسبوع.",
      subtitle: "اختر باقتك واستمتع بتنظيف منتظم بأسعار ثابتة مضمونة، مع أولوية في تحديد المواعيد وبدون عناء.",
      most_popular: "الأكثر طلباً",
      footnote: "كل الباقات: إلغاء شهري · لا رسوم خفية · شامل الضريبة · قابل للخصم الضريبي بالكامل كخدمة منزلية.",
      plans: {
        basic: {
          name: "تالكاني الأساسية",
          tagline: "صيانة شهرية للشقق الصغيرة.",
          price: "129",
          period: "/شهرياً",
          frequency: "مرة شهرياً · ساعتان",
          features: ["تنظيف كامل للشقة", "حمام ومطبخ بتفاصيل دقيقة", "مواد التنظيف مشمولة", "موظف/ة تنظيف ثابت/ة"],
          cta: "اختر الأساسية"
        },
        plus: {
          name: "تالكاني بلَس",
          tagline: "موصى بها — مثالية للعائلات وأصحاب الأعمال.",
          price: "279",
          period: "/شهرياً",
          frequency: "مرتان شهرياً · 3 ساعات",
          features: ["كل ما في الأساسية", "تنظيف النوافذ من الداخل", "تنظيف الثلاجة والفرن شهرياً", "أولوية في تحديد المواعيد", "إدارة المفاتيح مشمولة"],
          cta: "اختر بلَس"
        },
        premium: {
          name: "تالكاني بريميوم",
          tagline: "للبيوت والعيادات والمكاتب.",
          price: "649",
          period: "/شهرياً",
          frequency: "أسبوعياً · 3 ساعات",
          features: ["كل ما في بلَس", "تنظيف عميق أسبوعي", "النوافذ من الداخل والخارج", "مشرف ميداني مخصص", "تنظيف موسمي إضافي مجاناً"],
          cta: "اختر بريميوم"
        },
        combo: {
          name: "حزمة الحديقة + البيت",
          tagline: "أفضل قيمة — الحديقة والبيت من مزوّد واحد.",
          price: "399",
          period: "/شهرياً",
          frequency: "الحديقة أسبوعياً · البيت كل أسبوعين",
          features: [
            "عناية أسبوعية بالحديقة (عشب، أسوار، أوراق)",
            "تنظيف البيت كل أسبوعين · 3 ساعات",
            "التخلص من المخلفات النباتية حتى 1 م³ مشمول",
            "نفس الفريق، نفس يوم الأسبوع",
            "إيقاف/تعديل في أي وقت",
            "توفير ~75 € مقارنة بالحجز الفردي"
          ],
          cta: "اختر الحزمة",
          badge: "أفضل قيمة"
        }
      }
    },
    common: { loading: "جاري التحميل..." },
    languages_we_speak: {
      eyebrow: "نتحدّث لغتك",
      title: "خمس لغات، فريق واحد.",
      subtitle: "فريقنا يستشيرك ويخدمك بخمس لغات — هاتفياً، في الموقع، وعبر المحادثة المباشرة."
    },
    faq: {
      eyebrow: "أسئلة شائعة",
      title: "إجابات سريعة وصادقة.",
      subtitle: "لديك سؤال؟ على الأرجح ستجد الإجابة هنا. وإن لم تجد — اتصل بنا، نحن نردّ.",
      help_title: "سؤالك ليس مدرجاً؟",
      help_body: "اتصل بنا أو راسلنا بالبريد الإلكتروني. عادةً نردّ خلال ساعة واحدة في أوقات العمل."
    },
    case_studies: {
      hero_kpi_label: "نتائج بالأرقام",
      hero_kpi1_value: "40%",
      hero_kpi1_sub: "توفير في وقت التوقف لورش السيارات",
      hero_kpi2_value: "6 ساعات",
      hero_kpi2_sub: "نقل عاجل شامل التنظيف النهائي",
      hero_kpi3_value: "14 شهر",
      hero_kpi3_sub: "متوسط مدة عقود الشركات",
      hero_kpi4_value: "100%",
      hero_kpi4_sub: "قبول من شركات التأمين مع توثيق فيديو",
      back_home: "العودة إلى الرئيسية",
      eyebrow: "مشاريع حقيقية",
      title: "تالكاني في الميدان.",
      subtitle: "ثلاثة مشاريع حقيقية من الأشهر الأخيرة — تكاليف حقيقية، تحديات حقيقية، نتائج حقيقية. اضغط لقراءة القصة الكاملة.",
      challenge_label: "التحدّي",
      solution_label: "حلّنا",
      outcome_label: "النتيجة",
      investment: "الاستثمار",
      read_full: "اقرأ القصة كاملة",
      book_similar: "احجز خدمة مماثلة"
    },
    certifications: {
      eyebrow: "موثّق ومعتمد",
      title: "معايير ألمانية بلا تنازلات."
    },
    google_reviews: {
      eyebrow: "تقييمات",
      title: "ماذا يقول عملاؤنا على جوجل.",
      subtitle: "تقييمات موثّقة من عملاء حقيقيين — تُجمع بعد كل مهمة، بصدق وشفافية.",
      google_label: "تقييمات",
      based_on: "بناءً على {n} تقييماً",
      based_on_one: "بناءً على تقييم واحد",
      view_on_google: "اعرض على جوجل",
      empty: "لا تقييمات بعد — يسعدنا الحصول على تقييمك بعد أول حجز."
    },
    today_counter: {
      title: "مباشر · نشاط اليوم",
      today_label: "حجوزات اليوم",
      km_label: "كم تم قطعها",
      co2_label: "كغم CO₂ تم توفيرها"
    },
    exit_intent: {
      eyebrow: "انتظر!",
      title: "خصم 15 € لك.",
      subtitle: "احجز خدمة تالكاني الأولى اليوم ووفّر 15 € — صالح لجميع خدماتنا.",
      your_code: "كودك الشخصي",
      copy: "نسخ",
      copied: "تم النسخ!",
      cta: "احجز الآن مع الخصم",
      note: "صالح لمدة 24 ساعة، مرة واحدة لكل شخص",
      discount_label: "خصم"
    },
    sticky_cta: {
      title: "هل أنت جاهز لحجزك؟",
      subtitle: "احجز عبر الإنترنت في أقل من 60 ثانية — ضمان السعر الثابت",
      book_now: "احجز الآن"
    },
    mobile_call: {
      label: "اتصل الآن"
    },
    plz_checker: {
      eyebrow: "تحقق من الرمز البريدي",
      title: "هل نخدم منطقتك؟",
      subtitle: "أدخل رمزك البريدي الألماني (PLZ) وسنتحقق فوراً — مع تقدير المسافة ووقت الوصول.",
      label: "الرمز البريدي (PLZ)",
      placeholder: "مثال: 22047",
      check_btn: "تحقّق",
      checking: "جاري التحقق…",
      covered_yes: "نعم! نحن نخدم {city}.",
      distance: "حوالي {km} كم · وقت الوصول ~{min} دقيقة",
      express_available: "خدمة سريعة متاحة",
      express: "سريع",
      book_now: "احجز الآن",
      covered_no_title: "ليست ضمن منطقة خدمتنا المعتادة",
      covered_no_body: "لا نخدم هذه المنطقة بشكل منتظم. عند الطلب يمكننا تقديم عرض خاص لك.",
      contact_us: "أرسل طلباً",
      error_format: "يرجى إدخال رمز بريدي ألماني صالح (5 أرقام).",
      error_generic: "تعذّر التحقق، حاول لاحقاً."
    },
    referral: {
      eyebrow: "برنامج الإحالة من تالكاني",
      title: "ادعُ صديقاً — كلاكما يحصل على {eur} €.",
      subtitle: "شارك كودك مع أصدقائك وعائلتك. مع كل حجز أول لصديق دعوته، تحصلان كلاكما على رصيد 20 € لحجوزاتكما القادمة.",
      your_code: "كود الإحالة الخاص بك",
      copy_code: "نسخ",
      copied: "تم النسخ!",
      share_whatsapp: "واتساب",
      share_email: "بريد إلكتروني",
      share_copy: "نسخ الرسالة",
      email_subject: "وفّر 20 € مع تالكاني",
      stat_invites: "دعوات",
      stat_redeemed: "تم استبداله",
      stat_earned: "ربحت",
      footnote: "تحصل على {eur} € لكل إحالة ناجحة — تُضاف إلى رصيد حجزك القادم."
    },
    chat: {
      open: "فتح المحادثة المباشرة",
      teaser_msg: "أهلاً 👋 تحتاج عرض سعر سريع أو لديك سؤال؟ نحن هنا.",
      contextual_teasers: {
        default: "أهلاً 👋 تحتاج عرض سعر سريع أو لديك سؤال؟ نحن هنا.",
        book: "جاهز للحجز؟ 📅 يسعدنا مساعدتك في اختيار الموعد المناسب.",
        track: "لديك أسئلة عن شحنتك؟ 📦 نحن هنا للمساعدة فوراً.",
        price: "تحتاج سعراً ثابتاً؟ 💶 راسلنا — نرد خلال دقائق.",
        autoteile: "تبحث عن شريك توصيل لورشتك؟ 🔧 خدمة Express خلال 90 دقيقة متاحة.",
        umzug: "تخطّط لنقل؟ 📦 عرض سعر مجاني خلال 24 ساعة.",
        hausreinigung: "تنظيف أسبوعي أم لمرة واحدة؟ 🧹 نضع لك خطة تناسبك.",
        gartenpflege: "جاهز للموسم القادم؟ 🌿 نهتمّ بحديقتك — اسألنا.",
        reinigung: "تحتاج تنظيف منتظم للمكتب أو المبنى؟ ✨ نُعدّ لك خطة مناسبة.",
        dashboard: "أهلاً بعودتك! 👋 تريد حجز خدمة أخرى أو متابعة حالة طلب؟",
        booking_success: "شكراً لحجزك! 🎉 لديك أسئلة عن الخطوات التالية؟ نحن هنا.",
        blog: "تريد معرفة المزيد؟ 📖 اسألنا مباشرة — مع تفاصيل حالتك.",
        login: "مشكلة في تسجيل الدخول؟ 🔐 راسلنا — نساعدك فوراً.",
        services: "غير متأكد أي خدمة تناسبك؟ 🛠️ يسعدنا تقديم استشارة مجانية.",
        contact: "تفضّل المحادثة بدل النموذج؟ 💬 نرد خلال دقائق.",
        about: "تريد معرفة المزيد عن تالكاني؟ 👥 اسألنا — نُجيب شخصياً.",
        plakatservice: "وكالة إعلانات أو منظّم فعاليات؟ 📋 نبدّل ملصقاتكم في الموعد — مع توثيق بالصور."
      },
      close: "إغلاق المحادثة",
      header_title: "محادثة تالكاني المباشرة",
      header_subtitle: "رد فوري · مساعد ذكي + فريقنا",
      form_intro: "اطرح سؤالك — مساعدنا الذكي يرد فوراً، وفريقنا يتولّى عند الحاجة.",
      field_name: "الاسم",
      field_name_placeholder: "الاسم الكامل",
      field_email: "البريد الإلكتروني",
      field_email_placeholder: "name@example.com",
      field_message: "رسالتك",
      field_message_placeholder: "كيف يمكننا مساعدتك؟",
      start_btn: "ابدأ المحادثة",
      starting: "جاري البدء…",
      send: "إرسال",
      input_placeholder: "اكتب رسالة…",
      ai_label: "مساعد تالكاني",
      you_label: "أنت",
      admin_label: "فريق تالكاني",
      privacy_note: "بالبدء، أنت توافق على سياسة الخصوصية. نستخدم بياناتك فقط لمعالجة طلبك.",
      error_required: "يرجى تعبئة جميع الحقول.",
      error_generic: "حدث خطأ، يرجى المحاولة مرة أخرى.",
      loading: "جاري التحميل…",
      closed_msg: "انتهت هذه المحادثة.",
      start_new: "ابدأ محادثة جديدة",
      admin_title: "رسائل المحادثة المباشرة",
      admin_refresh: "تحديث",
      admin_empty: "لا توجد محادثات بعد.",
      admin_select: "اختر محادثة من اليمين.",
      admin_status_open: "مفتوحة",
      admin_status_closed: "مغلقة",
      admin_close: "إغلاق",
      admin_reopen: "إعادة فتح",
      admin_reply_placeholder: "اكتب ردك…",
      admin_you: "أنت (الفريق)",
      admin_closed_ok: "تم إغلاق المحادثة.",
      admin_reopened_ok: "تم إعادة فتح المحادثة.",
      book_cta: "احجز الآن",
      enable_notifications: "تفعيل الإشعارات"
    },
    vcard: {
      save_contact: "احفظ كجهة اتصال",
      saved: "تم الحفظ في جهات الاتصال!"
    },
    umzug_calc: {
      eyebrow: "حاسبة تكلفة النقل",
      title: "عرض سعر فوري لعملية النقل.",
      subtitle: "أجب على 4 أسئلة سريعة — نحسب نطاق سعر ثابت مع جميع الإضافات. غير ملزم 100%.",
      rooms: "عدد الغرف",
      rooms_1: "غرفة واحدة",
      rooms_2: "غرفتان",
      rooms_3: "3 غرف",
      rooms_4: "4 غرف فأكثر",
      floor: "الطابق",
      elevator: "هل يوجد مصعد؟",
      yes: "نعم",
      no: "لا",
      distance: "المسافة",
      distance_city: "داخل هامبورغ",
      distance_regional: "شمال ألمانيا",
      distance_national: "على مستوى البلاد",
      addons: "خدمات إضافية",
      addon_cleaning: "تنظيف نهائي",
      addon_cleaning_desc: "تسليم نظيف وجاهز",
      addon_painting: "أعمال الدهان",
      addon_painting_desc: "طلاء الجدران والإصلاحات",
      addon_packing: "خدمة التغليف",
      addon_packing_desc: "صناديق ومواد مشمولة",
      result_title: "التقدير الخاص بك",
      base_price: "السعر الأساسي",
      add_services: "الإضافات",
      combo_discount: "خصم الباقة (20%)",
      from_label: "ابتداءً من",
      note: "تقدير غير ملزم — السعر النهائي بعد المعاينة أو الاستشارة الهاتفية.",
      cta: "احجز النقل الآن"
    },
    districts: {
      eyebrow: "نطاق الخدمة · شمال ألمانيا",
      title: "نُوصّل في هامبورغ — وما وراءها.",
      subtitle: "أوقات وصول تقديرية من مقرّنا في فاندسبيك. نغطّي هامبورغ ومدنها الصغيرة المحيطة وأبرز مدن شمال ألمانيا — لوبيك، بريمن، كيل، هانوفر — يومياً.",
      filter_all: "جميع المناطق",
      filter_hamburg: "مدينة هامبورغ",
      filter_umland: "المنطقة المحيطة",
      filter_norddeutschland: "شمال ألمانيا",
      filter_express: "الإكسبرس فقط (≤ 22 دقيقة)",
      footnote: "أوقات الوصول تقديرية. الوقت المؤكد بعد الحجز."
    },
    gallery: {
      eyebrow: "قبل · بعد",
      title: "نتائج حقيقية من عملياتنا.",
      subtitle: "موثقة مباشرة من فِرَقنا — قبل وبعد كل عملية. لا صور مخزون.",
      before: "قبل",
      after: "بعد"
    },
    track: {
      eyebrow: "تتبع الحجز",
      title: "حالة حجزك",
      subtitle: "أدخل رقم الحجز. للاطلاع على التفاصيل الكاملة، أدخل أيضاً الإيميل المستخدم عند الحجز.",
      back: "العودة إلى الصفحة الرئيسية",
      booking_id: "رقم الحجز",
      email_optional: "الإيميل (اختياري)",
      track_btn: "تتبّع",
      status: "الحالة الحالية",
      date: "الموعد",
      address: "العنوان",
      phone: "الهاتف",
      customer: "العميل",
      email_hint: "أدخل إيميلك لرؤية العنوان والهاتف والتفاصيل.",
      error_generic: "تعذّر التحميل. يرجى التحقق من الرقم."
    }
  }
};

export const SERVICES = [
  "lieferung",
  "autoteile",
  "escooter_service",
  "umzug",
  "reinigung",
  "zweimann_handling",
  "hausreinigung",
  "gartenpflege",
  "regenrinne_reinigung",
  "winterdienst",
  "plakatservice"
];

// Generated images (Talkani-branded via Gemini Nano Banana) live in /generated/*.png
export const SERVICE_IMAGES = {
  lieferung: "/generated/hero.png",
  autoteile: "/generated/autoteile.png",
  escooter_service: "/generated/escooter.png",
  umzug: "/generated/umzug.png",
  reinigung: "/generated/reinigung.png",
  hausreinigung: "/generated/hausreinigung.png",
  gartenpflege: "/generated/gartenpflege.png",
  regenrinne_reinigung: "/generated/regenrinne.png",
  winterdienst: "/generated/winterdienst.png",
  zweimann_handling: "/generated/zweimann_handling.png",
  plakatservice: "/generated/plakatservice.png"
};

export const SPECIALTY_DELIVERIES = [
  { key: "blumen", image: "/generated/blumen.png" },
  { key: "backwaren", image: "/generated/backwaren.png" },
  { key: "zeitungen", image: "/generated/zeitungen.png" },
  { key: "medikamente", image: "/generated/medikamente.png" },
  { key: "andere", image: "/generated/blumen.png", isCustom: true }
];

export const HERO_IMAGE = "/generated/hero.png";
